const sqlState = {
  sqlInsert: 1,
  sqlUpdate: 2,
  sqlDelete: 3,
  sqlUnchange: 0,
};

const queryOptions = {
  PaidTo: 1,
  ReceiveFrom: 2,
  CostName: 3,
  CostCenterDtl: 4,
  BusinessAreaForGL: 5,
  CoaForGL: 6,
  CostCenterForGL: 7,
  RefCenterForGL: 8,
  CoaForAV: 9,
  CoaForConfig: 10,
  CoaForConfig1: 11,
  BusinessAreaForAV: 12,
  VoucherTypeForTC: 13,
  CostCenterForTC: 14,
  BusinessAreaForTC: 15,
  CoaForTC: 16,
  VoucherForTC: 17,
  VoucherForUT: 18,
  CostCenterForALL: 20,
  VoucherForPV: 19,
  CostCenterForCT: 21,
  DB: 22,
  CostCenterForTB: 23,
  DBAC: 24,
  CoaForCS: 25,
  BusinessAreaForCT: 26,
  CoaForCT: 27,
  DBACTS: 28,
  VoucherTypeForTDB: 29,
  CoaForTS: 30,
  CoaForCSOB: 31,
  CoaForTree: 32,
  CoaForParent: 33,
  BusinessAreaForTSB: 34,
  BusinessAreaTSB: 42,
  BusinessAreaGL: 35,
  CoaTSB: 37,
  DBAcc: 38,
  CoaTSBA: 54,
  CoaCB: 48,
  CoaCT: 55,
  CostCenterForCS: 39,
  CoaForCB: 47,
  CoaForCFS: 40,
  CoaForTSBR: 41,
  CoaForTSB: 43,
  CoaForSB: 44,
  CostCenterForTSB: 45,
  CostCenterForTSC: 46,
  BusinessAreaCB: 49,
  BusinessAreaForRP: 50,
  BusinessAreaRP: 51,
  CoaRP: 52,
  CoaAVD: 53,
  CoaForBudget: 56,
  CostCenterForCR: 57,
  CoaForBd: 58,
  CoaForBV: 59,
  CoaForBDA: 63,
  PRIV_NO: 50148,
  CoaForQJ: 60,
  CostCenterForQJ: 61,
  B_A_QJ: 62,
  CoaForDSR: 67,
  CoaForBFE: 68,
  CostCenterForBFE: 69,
  BusinessAreaBEF: 70,
  VoucherForBFE: 71,
  VoucherByVNO: 72,
  CostCenterNO: 73,
  GroupCostCenter: 74,
  LookupNo: 1026,
};

const voucherType = {
  DebitVoucher: 1,
  CreditVoucher: 2,
  PurchaseVoucher: 19,
};

const shortMonths = [
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
];
let methodTypeList = [
  { VALUE: "SL", TEXT: "Straight Line" },
  { VALUE: "DB", TEXT: "Declining Balance" },
  { VALUE: "SD", TEXT: "Sum of the years digits method" },
];
let periodTypeList = [
  { VALUE: "Y", TEXT: "Yearly " },
  { VALUE: "H", TEXT: "Half Yearly" },
  { VALUE: "Q", TEXT: "Quarterly" },
  { VALUE: "M", TEXT: "Monthly" },
];

const conditionStatus = [
  { TEXT: "All", VALUE: "A" },
  { TEXT: "Employee", VALUE: "E" },
  { TEXT: "Designation", VALUE: "J" },
  { TEXT: "Business Unit", VALUE: "B" },
  { TEXT: "Line Name", VALUE: "L" },
];
const conditionRosterStatus = [
  { TEXT: "All", VALUE: "A" },
  { TEXT: "Employee", VALUE: "E" },
  { TEXT: "Designation", VALUE: "J" },
  { TEXT: "Business Unit", VALUE: "B" },
];
const tranDate = [{ TEXT: "Tran Date", VALUE: "T" }];

const sa1008FilterType = [
  { TEXT: "Privileged", VALUE: "P" },
  { TEXT: "Non-Privileged", VALUE: "N" },
];

const transactionType = {
  Dr: "Dr",
  Cr: "Cr",
};

const transactionTypeUpperCase = {
  Dr: "DR",
  Cr: "CR",
};
const carbonList = [
  { TEXT: "YES", VALUE: 0 },
  { TEXT: "NO", VALUE: 1 },
];
const shiftWiseList = [
  { TEXT: "YES", VALUE: "1" },
  { TEXT: "NO", VALUE: "0" },
];
const imageShowList = [
  { TEXT: "YES", VALUE: "Y" },
  { TEXT: "NO", VALUE: "N" },
];
const imageHolderList = [
  { TEXT: "ALL", VALUE: null },
  { TEXT: "YES", VALUE: "1" },
  { TEXT: "NO", VALUE: "0" },
];
const previewDataForList = [
  { VALUE: "O", TEXT: "Overtime Process" },
  { VALUE: "S", TEXT: "Salary Process" },
];
const compateWithList = [
  { VALUE: "G", TEXT: "Salary Gross" },
  { VALUE: "P", TEXT: "Payble Gross" },
];

const methodHR1007 = [
  { VALUE: "S", TEXT: "Simple" },
  { VALUE: "C", TEXT: "Compound" },
];

const reportTypeApplicant = [
  { TEXT: "Summary", VALUE: 1 },
  { TEXT: "Detail", VALUE: 0 },
];

const otStatus = [{ VALUE: 1, TEXT: "A" }];

const statisticsType = [
  { TEXT: "Date wise Attendance Statistics", VALUE: "0" },
  { TEXT: "Employee wise Attendance Statistics", VALUE: "1" },
  { TEXT: "BU wise Attendance Statistics", VALUE: "2" },
  { TEXT: "Line wise Attendance Statistics", VALUE: "16" },
  { TEXT: "Jobtitle Wise Daily Manpower", VALUE: "10" },
  { TEXT: "Daily Manpower Detail", VALUE: "3" },
  { TEXT: "Daily Manpower Summary", VALUE: "4" },
  { TEXT: "Daily BU wise OT Summary", VALUE: "13" },
  { TEXT: "BU wise Attendance summary", VALUE: "11" },
  { TEXT: "Monthly Attendance Statistic", VALUE: "5" },
  { TEXT: "Monthly Attendance Statistic(Def.)", VALUE: "6" },
  { TEXT: "Overtime Statistics", VALUE: "7" },
  { TEXT: "Overtime Statistics (Default)", VALUE: "8" },
];

const accountType = {
  Assets: "A",
  Expenses: "E",
  Liabilities: "L",
  Income: "I",
};

const preferred = {
  Mobile: "M",
  Office: "O",
  Home: "H",
};

const billStatus = {
  InvoiceDate: "B",
  RcvDate: "R",
  LcDate: "W",
};

const genderStatus = {
  Male: "M",
  Female: "F",
};

const maturityType = {
  Acceptance: "A",
  Delivery: "D",
  BL: "B",
  Negotiation: "N",
  Advance: "D",
};
const genderStatus2 = [
  { TEXT: "Others", VALUE: null },
  { TEXT: "Male", VALUE: "M" },
  { TEXT: "Female", VALUE: "F" },
];
const genderStatusHR1218 = [
  { TEXT: "Male", VALUE: 1 },
  { TEXT: "Female", VALUE: 2 },
  { TEXT: "Others", VALUE: 3 },
  { TEXT: "", VALUE: null },
];

const genderSa1028 = [
  { TEXT: "Male", VALUE: "M" },
  { TEXT: "Female", VALUE: "F" },
];

const POStatus = [
  { TEXT: "With PO", VALUE: 1 },
  { TEXT: "Without PO", VALUE: 2 },
];
const lcStatus = [
  { TEXT: "Without LC", VALUE: 2 },
  { TEXT: "With LC", VALUE: 1 },
];

const reportTitleForSalaryStatement = [
  { TEXT: "Head Office", VALUE: "Head Office" },
];

const filterOptionType = {
  AllChequeId: "A",
  VoidChequeId: "V",
  PostingChequeIdOnly: "PO",
  UnpostedChequeId: "UP",
  AllButVoid: "AV",
};

const coaIndentificationType = {};

const coaDisplayType = {};

const postingStatus = {
  PostedOnly: "AC_LEDGER_V",
  // all :'AC_UPLEDGER_V'
};

const postStatusType = {
  Posted: "PO",
  Unposted: "UPO",
  All: "A",
};

const postStatusTypeNumber = {
  Posted: 1,
  Unposted: 0,
};
const postStatusTypeNumberIn1027 = {
  Unposted: 0,
};

const issueTypeList = {
  Posted: 1,
  Unposted: 0,
};

const checkFlag = {
  Checked: 1,
  Unchecked: 0,
  All: null,
};

const postStatusType1 = {
  Posted: 1,
  Unposted: 0,
};

const postedStatus = [
  { VALUE: 1, TEXT: "Posted" },
  { VALUE: 0, TEXT: "Unposted" },
];

const statusHr1192 = [
  { VALUE: "A", TEXT: "Checked" },
  { VALUE: "W", TEXT: "Not Checked" },
];

const trnsactionTypeIn1026 = [
  { VALUE: 1, TEXT: "Posted" },
  { VALUE: 0, TEXT: "Unposted" },
];

const statusGroup = [
  { VALUE: 1, TEXT: "All" },
  { VALUE: 2, TEXT: "Internal" },
  { VALUE: 3, TEXT: "External" },
];

const postingStatusType = {
  PostedOnly: 1,
};
const status = {
  Approved: 1,
  Waiting: 0,
};

const moneyReqStatus01 = {
  Waiting: "W",
  Approved: "A",
  Denied: "H",
};

const voucherModeType = {
  CashInflow: "CI",
  CashOutflow: "CO",
  Adjustments: "AD",
  Contra: "CT",
  Journal: "JL",
  Others: "OT",
};

const specialAwardBonusType = {
  Basic: 1,
};

const budgetModeType = {
  Budget: "B",
  HeadWiseSummary: "H",
  SummaryDetails: "D",
  BudgetAllocationReport: "BA",
  BudgetDetailsReport: "DA",
  BudgetVarianceReport: "BV",
};

const generationType = {
  Monthly: "M",
  FYYearly: "Y",
  Daily: "D",
};

const duration = {
  Day: "D",
  Month: "M",
  Year: "Y",
};

const indentificationAccountType = [
  { TEXT: "Cash", VALUE: "CS" },
  { TEXT: "Bank", VALUE: "B" },
  { TEXT: "Profit/Loss", VALUE: "PL" },
  { TEXT: "Account Receivable", VALUE: "AR" },
  { TEXT: "Account Payable", VALUE: "AP" },
  { TEXT: "Fixed Asset", VALUE: "FA" },
  { TEXT: "Tax", VALUE: "TX" },
  { TEXT: "VAT", VALUE: "VT" },
  { TEXT: "Discount Receive", VALUE: "DR" },
  { TEXT: "Discount Paid", VALUE: "DP" },
  { TEXT: "Cash & Bank", VALUE: "CB" },
  { TEXT: "Rounding Deference", VALUE: "RD" },
  { TEXT: "Inventory", VALUE: "IN" },
];

const integratedModuleType = {
  Accounts: "AC",
  Purchase: "PR",
  Sales: "SL",
  Inventory: "IN",
  OfficeOrg: "OO",
  HRM: "HR",
  CashManagement: "CM",
};
const stockCategory = [
  { VALUE: "1", TEXT: "Matrix" },
  { VALUE: "2", TEXT: "Item (Only with stock)" },
  { VALUE: "3", TEXT: "Bu wise Item Stock" },
  { VALUE: "4", TEXT: "Bu Wise Item Stock(BL)" },
];

const confirmedType = {
  None: 2,
  Yes: 1,
  No: 0,
};

const nameCodeStyleType = {
  NameCode: "NC",
  CodeName: "CN",
  Name: "N",
  Code: "C",
};

const balanceType = {
  Positive: "P",
  Negative: "N",
};

const settlementType = {
  Cash: "C",
  Void: "V",
  Waiting: "W",
};

const dateType = {
  ChequeDate: "C",
  PrepareDate: "P",
};

const ccBaType = {
  Fixed: "F",
  List: "L",
  Optional: "O",
  Select: "S",
};

const dayBookreportTypeList = {
  Default: "D",
  WithoutCostCenter: "C",
  VoucherList: "V",
  WithCashBank: "S",
};

const maritialStatus = {
  Single: "S",
  Married: "M",
  NotAssained: "O",
};

const rcvStatus = {
  General: "G",
  Warrenty: "W",
  All: null,
};

const transferTypeStatus = {
  Transfer: "Transfer",
  Promotion: "Promotion",
  Adjustment: "Adjustment",
};

const transferTypeStatus01 = {
  Transfer: "Transfer",
  Adjustment: "Adjustment",
};

const maintainceType = {
  RegularMaintenance: "R",
  IrregularMaintenance: "I",
  YearlyMaintenance: "Y",
  Decoration: "D",
  Accident: "A",
  Fuel: "F",
};
const promotionTypeStatus = {
  Increment: "Increment",
  Promotion: "Promotion",
  Adjustment: "Adjustment",
  "Transfer & Promotion": "Transfer & Promotion",
  "Selection Grade": "Selection Grade",
};
const discountType = {
  Regular: "R",
  Panalty: "P",
};

const overTimeReqStatusList = {
  Waiting: "W",
  Approved: "A",
  Denied: "D",
};
const in1295OverTimeReqStatusList = {
  Waiting: "W",
  Approved: "A",
};

const statusList = [
  { VALUE: "W", TEXT: "Waiting" },
  { VALUE: "A", TEXT: "Approved" },
];

const statusListhr1188 = [
  { VALUE: "W", TEXT: "Waiting" },
  { VALUE: "A", TEXT: "Approved" },
  { VALUE: "R", TEXT: "Reject" },
];

const statusListhr1189 = [
  { VALUE: "W", TEXT: "Not Assigned" },
  { VALUE: "A", TEXT: "Assigned" },
];

const installmentList = [
  { VALUE: "F", TEXT: "First Installment" },
  { VALUE: "N", TEXT: "Second Installment" },
];

const prePRLListStatus = [
  { VALUE: "W", TEXT: "Waiting" },
  { VALUE: "SP", TEXT: "Submit Pending" },
  { VALUE: "D", TEXT: "Complete" },
  { VALUE: "PD", TEXT: "PRL Date Over" },
];

const statusListhr1190 = [
  { VALUE: 0, TEXT: "Not Submitted" },
  { VALUE: 1, TEXT: "Submitted" },
  { VALUE: 2, TEXT: "Rejected" },
];

const statusPrl = [
  { VALUE: 0, TEXT: "Waiting" },
  { VALUE: 1, TEXT: "Submitted" },
];

const status1 = {
  All: "",
  Unrealized: "Unrealized",
  Negotiated: "Negotiated",
  BankAccepted: "Bank Accepted",
  BankSubmitted: "Bank Submitted",
  PartyAccepted: "Party Accepted",
  PartySubmitted: "Party Submitted",
  Initialized: "Initialized",
  Realized: "Realized",
  Paymentreceived: "Payment received",
};

const allocateCostCenters = {
  ActiveCostcenterAllocation: 1,
  ActiveBusinessAreaAllocation: 2,
  None: null,
};
const invoiceCategory = [
  { VALUE: "I", TEXT: "Purchase" },
  { VALUE: "L", TEXT: "Loan" },
];

const promotionTypeStatusSingle = [{ VALUE: "Promotion", TEXT: "Promotion" }];

const reportFormat = [
  { VALUE: 1, TEXT: "T-Format 1" },
  { VALUE: 2, TEXT: "T-Format 2" },
  { VALUE: 3, TEXT: "T-Format 3" },
];

const reportHR1182 = [
  { VALUE: 1, TEXT: "Application Report" },
  // { VALUE: 2, TEXT: "Application Report(Blank)" }
];

const maritialStatusSa1028 = [
  { VALUE: "S", TEXT: "Single" },
  { VALUE: "M", TEXT: "Married" },
  { VALUE: "U", TEXT: "Unmarried" },
  { VALUE: "O", TEXT: "Others" },
];

const incommingProtocolList = [
  { VALUE: "IMAP", TEXT: "IMAP" },
  { VALUE: "POP3", TEXT: "POP3" },
];
const outgoingProtocolList = [
  { VALUE: "SMTP", TEXT: "SMTP" },
  { VALUE: "FTP", TEXT: "FTP" },
];

const inReportFormat = [
  { VALUE: "IN_22385", TEXT: "Format-1" },
  { VALUE: "IN_2234", TEXT: "Format-2" },
  { VALUE: "IN_2236", TEXT: "Format-3" },
  { VALUE: "IN_28118", TEXT: "Format-4" },
  { VALUE: "IN_28119", TEXT: "Format-5" },
];
// const inReportFormat = [
//   { VALUE: 1, TEXT: "Format-1" },
//   { VALUE: 2, TEXT: "Format-2" },
//   { VALUE: 3, TEXT: "Format-3" },
//   { VALUE: 4, TEXT: "Format-4" },
// ];

const recieveStatusLoan = [
  { VALUE: null, TEXT: "All" },
  { VALUE: 1, TEXT: "Paid" },
  { VALUE: 0, TEXT: "Unpaid" },
];
const reportFormatList = [
  { VALUE: "HR_2086", TEXT: "Format 1(Default)" },
  { VALUE: "HR_2081", TEXT: "Format 2(Dynamic)" },
  { VALUE: "HR_2087", TEXT: "Format 3" },
  { VALUE: "HR_2088", TEXT: "Format 4 (English)" },
  { VALUE: "HR_2089", TEXT: "Format 5" },
  { VALUE: "HR_20810", TEXT: "Format 1( 4 Hour )" },
  { VALUE: "HR_20811", TEXT: "Format 5(Bangla-A)" },
  { VALUE: "HR_20812", TEXT: "Format 5(Bangla-C)" },
  { VALUE: "HR_20813", TEXT: "Format 6(Bangla-A)" },
];

const reportTypeListOne = [
  { VALUE: "1", TEXT: "Report 1" },
  { VALUE: "0", TEXT: "Format 2" },
  { VALUE: "3", TEXT: "Format 3 (Default)" },
  { VALUE: "4", TEXT: "Format 4 (Default)" },
  { VALUE: "5", TEXT: "Format 5 (Default)" },
  { VALUE: "6", TEXT: "Detail Report 6" },
  { VALUE: "7", TEXT: "Detail Report 7 ( On Salary Process)" },
  { VALUE: "8", TEXT: "Detail Report 8 ( On Salary Process 2 Hr.)" },
  { VALUE: "9", TEXT: "Detail Report 9 ( With IN/OUT)" },
  { VALUE: "10", TEXT: "Detail Report 10 (With Holiday/Weekend Present)" },
  { VALUE: "11", TEXT: "Report 11 (Default)" },
  { VALUE: "12", TEXT: "Report 12" },
  { VALUE: "13", TEXT: "Report 11 (Hourly)" },
];

const SummeryReportTypeList = [
  { VALUE: "1", TEXT: "Report 1" },
  { VALUE: "2", TEXT: "Report 2" },
  { VALUE: "3", TEXT: "Pay Order Report" },
];

const rbType = [
  { VALUE: "W", TEXT: "WO" },
  { VALUE: "B", TEXT: "Both" },
  { VALUE: "L", TEXT: "L/C" },
];

const transactionType1113 = [
  { VALUE: "S", TEXT: "Service" },
  { VALUE: "I", TEXT: "Goods/Purchase" },
  { VALUE: "W", TEXT: "Works" },
];

const reportFormatFourStyle = [
  { VALUE: 1, TEXT: "Format 1" },
  { VALUE: 2, TEXT: "Format 2" },
  { VALUE: 3, TEXT: "Format 3" },
  { VALUE: 4, TEXT: "Format 4" },
];
const reportFormatFourStyleOne = [
  { VALUE: 1, TEXT: "Format One" },
  { VALUE: 2, TEXT: "Format Two" },
  { VALUE: 3, TEXT: "Format Three" },
  { VALUE: 4, TEXT: "Format Four" },
];

const reportFormatFourStyleWo = [
  { VALUE: 1, TEXT: "Format 1" },
  { VALUE: 2, TEXT: "Format 2" },
  { VALUE: 3, TEXT: "Format 3" },
  { VALUE: 4, TEXT: "Format 4" },
  { VALUE: 5, TEXT: "Format 5" },
  { VALUE: 6, TEXT: "Format 6" },
  { VALUE: 7, TEXT: "Format 7" },
];

const reportFormatFourStyleWoIn1297 = [{ VALUE: 2, TEXT: "Purchase Report" }];

const reportFormatFourStyleOne1 = [
  { VALUE: "1", TEXT: "Format One" },
  { VALUE: "2", TEXT: "Format Two" },
  { VALUE: "3", TEXT: "Format Three" },
  { VALUE: "4", TEXT: "Format Four" },
];

const printReport = [
  { VALUE: "2", TEXT: "Office Copy" },
  { VALUE: "1", TEXT: "Vendor's Copy" },
];

const dobProvedBy = [
  { VALUE: "National ID", TEXT: "National ID" },
  { VALUE: "Birth Certificate", TEXT: "Birth Certificate" },
  { VALUE: "Educational Certificate", TEXT: "Educational Certificate" },
  { VALUE: "Doctors Prescription", TEXT: "Doctors Prescription" },
];

const reportOptionList = [
  { VALUE: 0, TEXT: "In Active" },
  { VALUE: 1, TEXT: "Active" },
  { VALUE: null, TEXT: "All" },
  { VALUE: 3, TEXT: "Report XLS" },
];
const activeStatusList = [
  { VALUE: 1, TEXT: "Active" },
  { VALUE: 2, TEXT: "Inactive" },
];

const activeStatusListSa1028 = [
  { VALUE: "A", TEXT: "All" },
  { VALUE: "P", TEXT: "Privileged" },
  { VALUE: "N", TEXT: "Non-Privileged" },
];

const activeStatusListHr1016 = [
  { VALUE: 1, TEXT: "Active" },
  { VALUE: 0, TEXT: "Inactive" },
];

const missingStatusList = [
  { VALUE: 1, TEXT: "In Time" },
  { VALUE: 2, TEXT: "Out Time" },
];

const adjustWithList = [
  { VALUE: "I", TEXT: "In Time" },
  { VALUE: "O", TEXT: "Out Time" },
  { VALUE: "OS", TEXT: "Out time based on shift time" },
  { VALUE: "IS", TEXT: "In time based on shift time" },
];

const adjustTypeList = [
  { VALUE: "I", TEXT: "Increase" },
  { VALUE: "D", TEXT: "Decrease" },
];

const woTypeList = [
  { VALUE: "S", TEXT: "Service" },
  { VALUE: "I", TEXT: "Goods/Purchase" },
  { VALUE: "W", TEXT: "Works" },
];

const ActualIncrNoList = [
  { VALUE: "G", TEXT: "Gross" },
  { VALUE: "B", TEXT: "Basic" },
];
const printTypeList = [
  { VALUE: 1, TEXT: "Single (A4)" },
  { VALUE: 2, TEXT: "Twice per page" },
  { VALUE: 3, TEXT: "Single (Half Page)" },
];
const reportSizeList = [
  { VALUE: "11.69x8.27", TEXT: "A4" },
  { VALUE: "14x8.5", TEXT: "Legal" },
  { VALUE: "11x8.5", TEXT: "Letter" },
  { VALUE: "14x11", TEXT: "Fanfold(14x11)" },
  { VALUE: "15x8.5", TEXT: "Width '15' x Height '8.5'" },
  { VALUE: "16x8.5", TEXT: "Width '16' x Height '8.5'" },
  { VALUE: "17x8.5", TEXT: "Width '17' x Height '8.5'" },
  { VALUE: "10.5x8.27", TEXT: "10.5x8.27" },
];
const storeReportList = [
  { VALUE: "1", TEXT: "Stock Register" },
  { VALUE: "2", TEXT: "Item Stock Batch Role Details" },
  { VALUE: "3", TEXT: "Stock Transaction Summary" },
  { VALUE: "4", TEXT: "Stock Register(Yarn)" },
  { VALUE: "5", TEXT: "Item Stock Batch Wise" },
  { VALUE: "6", TEXT: "Item Consumption" },
  { VALUE: "7", TEXT: "Stock Register( With MC & Internal)" },
  { VALUE: "8", TEXT: "Lot Wise Stock Register" },
  { VALUE: "9", TEXT: "Company Wise Stock Report" },
  { VALUE: "10", TEXT: "Stock Recapsulation Report (Fabric)" },
  { VALUE: "11", TEXT: "Stock Recapsulation Detail Report" },
  { VALUE: "12", TEXT: "Buyer Wise Stock" },
  { VALUE: "13", TEXT: "Item Wise Batch And Supplier Details Report" },
  { VALUE: "14", TEXT: "Stock Register (Hazard)" },
  { VALUE: "15", TEXT: "Stock Recapsulation Report" },
];
const reportFormatListOne = [
  { VALUE: "1", TEXT: "Format One" },
  { VALUE: "2", TEXT: "Format Two" },
  { VALUE: "3", TEXT: "Format Three" },
  { VALUE: "4", TEXT: "Format Four" },
  { VALUE: "5", TEXT: "Format Five" },
  { VALUE: "6", TEXT: "Format Six" },
  { VALUE: "7", TEXT: "Format Seven" },
  { VALUE: "8", TEXT: "Format Eight" },
  { VALUE: "9", TEXT: "Format Nine" },
  { VALUE: "10", TEXT: "Format Ten" },
  { VALUE: "11", TEXT: "New Emp" },
  { VALUE: "12", TEXT: "Lefty Emp" },
  { VALUE: "13", TEXT: "Format Eleven(New)" },
  { VALUE: "14", TEXT: "Format Eleven(Lefty)" },
  { VALUE: "15", TEXT: "Format Twelve" },
  { VALUE: "16", TEXT: "Format Thirteen (R)" },
  { VALUE: "17", TEXT: "Format Thirteen (L)" },
  { VALUE: "18", TEXT: "UTL Salary Sheet" },
  { VALUE: "19", TEXT: "Bangla Format" },
];
const reportFormatListForAllowance = [
  { VALUE: "1", TEXT: "Format 1" },
  { VALUE: "2", TEXT: "Format 2" },
  { VALUE: "3", TEXT: "Format 3" },
  { VALUE: "4", TEXT: "Format 4" },
  { VALUE: "5", TEXT: "Format 5 (Default)" },
  { VALUE: "6", TEXT: "Format 6 (Default)" },
  { VALUE: "7", TEXT: "Format 7 (Default)" },
  { VALUE: "8", TEXT: "Format 8 (Dynamic)" },
  { VALUE: "9", TEXT: "Format 9 (Eid Bonus)" },
  { VALUE: "10", TEXT: "Format 10(Partial Salary)" },
  { VALUE: "11", TEXT: "Format 11(Non Prod)" },
  { VALUE: "12", TEXT: "Format 12(Hourly)" },
  { VALUE: "13", TEXT: "Format 13(Summary Hourly)" },
  { VALUE: "14", TEXT: "Format-14" },
];

const reportFormatListTwo = [
  { VALUE: "10", TEXT: "Tick Sheet" },
  { VALUE: "11", TEXT: "Tick Sheet(New)" },
  { VALUE: "12", TEXT: "Tick Sheet(Lefty)" },
  { VALUE: "13", TEXT: "Sign Sheet" },
  { VALUE: "16", TEXT: "Sign Sheet(Lefty)" },
  { VALUE: "14", TEXT: "Bank Sheet" },
  { VALUE: "15", TEXT: "Denomination(Company Wise)" },
  { VALUE: "17", TEXT: "Denomination(BU Wise)" },
  { VALUE: "18", TEXT: "Lefty Without Pay" },
  { VALUE: "19", TEXT: "Payment Sheet (Format Twelve)" },
  { VALUE: "20", TEXT: "Bank Sheet (Format Nine)" },
  { VALUE: "21", TEXT: "Token Slip (Sign Sheet)" },
  { VALUE: "22", TEXT: "Extra OT Payment Sheet ( F-13)" },
  { VALUE: "23", TEXT: "Extra OP Payment Sheet(Lefty)" },
  { VALUE: "24", TEXT: "Extra OP Payment Sheet" },
];

const reportFormatListThree = [
  { VALUE: "1", TEXT: "Salary Sheet 4 Hr." },
  { VALUE: "2", TEXT: "Sign Sheet 2 Hr." },
  { VALUE: "3", TEXT: "Sign Sheet 1 Hr." },
  { VALUE: "4", TEXT: "Sign Sheet 4 Hr." },
  { VALUE: "5", TEXT: "Balance OT" },
  { VALUE: "6", TEXT: "Sign Sheet 2 Hr. (Lefty)" },
  { VALUE: "7", TEXT: "Balance OT (Lefty)" },
  { VALUE: "8", TEXT: "Sign Sheet 1 Hr. (Lefty)" },
];

const perChantageList = [
  { TEXT: "With Percentage", VALUE: 0 },
  { TEXT: "Without Percentage", VALUE: 1 },
];

const dicsType = [
  { TEXT: "Percentage", VALUE: "P" },
  { TEXT: "Amount", VALUE: "A" },
];
const dicsOn = [
  { TEXT: "Item Price", VALUE: "P" },
  { TEXT: "Item Sales Price", VALUE: "S" },
];
const reportCategoryTypeList = [
  { VALUE: 1, TEXT: "Opening - Transaction Detail - Closing Detail" },
  { VALUE: 2, TEXT: "Opening Detail" },
  { VALUE: 3, TEXT: "Opening Transaction Details" },
  { VALUE: 4, TEXT: "Transaction Details" },
];

const reportOptionTypeList = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: 1, TEXT: "Active" },
  { VALUE: 0, TEXT: "Inactive" },
  { VALUE: 3, TEXT: "Report XLS" },
];
const salaryOperator = [
  { VALUE: "%3E=", TEXT: ">=" },
  { VALUE: "%3E", TEXT: ">" },
  { VALUE: "%3C=", TEXT: "<=" },
  { VALUE: "%3C", TEXT: "<" },
  { VALUE: "=", TEXT: "=" },
];

const transferTypeStatus1 = [
  { VALUE: "Transfer", TEXT: "Transfer" },
  { VALUE: "Promotion", TEXT: "Promotion" },
  { VALUE: "Adjustment", TEXT: "Adjustment" },
];

const reportTypeList = [
  { VALUE: 1, TEXT: "Landscape?" },
  { VALUE: 2, TEXT: "With Description?" },
  { VALUE: 3, TEXT: "Show Running Balance?" },
  { VALUE: 4, TEXT: "Group Ledger Report?" },
  { VALUE: 5, TEXT: "Monthly Ledger Report?" },
  { VALUE: 6, TEXT: "Monthly Statement?" },
  { VALUE: 7, TEXT: "Monthly Statement (Group)?" },
];
const reportTypeListTwo = [
  { VALUE: 1, TEXT: "Grade List" },
  { VALUE: 2, TEXT: "Employee's with basic" },
  { VALUE: 3, TEXT: "Employee's Payroll" },
];

const reportTypeListThree = [
  { VALUE: 1, TEXT: "Default" },
  { VALUE: 2, TEXT: "H&M INVOICE" },
  { VALUE: 3, TEXT: "H&M COF Format-1" },
  { VALUE: 4, TEXT: "H&M COF Format-2" },
  { VALUE: 5, TEXT: "GAP INVOICE" },
  { VALUE: 6, TEXT: "GAP COF" },
  { VALUE: 7, TEXT: "Invoice IN Excel" },
  { VALUE: 8, TEXT: "BENEFICIARY CERTIFICATE" },
];

const reportCategory = [
  { VALUE: 1, TEXT: "H&M" },
  { VALUE: 2, TEXT: "GAP" },
];

const reportEarnLeavePayment = [
  { VALUE: "S", TEXT: "Salary Sheet" },
  { VALUE: "P", TEXT: "Payment Sheet" },
  { VALUE: "C", TEXT: "Compliance" },
];

const valueTipe = [
  { VALUE: "Y", TEXT: "With Value" },
  { VALUE: "N", TEXT: "Without Value" },
];

const inventoryTypes = {
  OpeningStock: "OS",
  ClosingStock: "CS",
};
const inventoryType = [
  { VALUE: null, TEXT: "All" },
  { VALUE: "F", TEXT: "FIFO" },
  { VALUE: "L", TEXT: "LIFO" },
  { VALUE: "E", TEXT: "FEFO" },
  { VALUE: "W", TEXT: "Weighted Avg" },
  { VALUE: "B", TEXT: "Batch" },
];
const inventoryMethos = [
  { VALUE: null, TEXT: "Select" },
  { VALUE: "F", TEXT: "FIFO" },
  { VALUE: "L", TEXT: "LIFO" },
  { VALUE: "W", TEXT: "WA" },
  { VALUE: "B", TEXT: "BATCH" },
  { VALUE: "D", TEXT: "@ O Rate" },
];

const activeType = {
  All: null,
  Yes: 1,
  No: 0,
};

const session = {
  FireUrgent: 1,
  Urgent: 2,
  Normal: 3,
};

const activeType1 = {
  Yes: 1,
  No: 0,
};

const activeStatus = {
  Active: 1,
  Inactive: 0,
  // All: null
};
const activeStatusTwo = [
  { VALUE: "1", TEXT: "Active" },
  { VALUE: "0", TEXT: "Inactive" },
];
const salesInvoiceDateType = [
  { VALUE: "I", TEXT: "Invoice" },
  { VALUE: "DO", TEXT: "DO Date" },
  { VALUE: "DC", TEXT: "DC Date" },
];
const fromOrderInvoice = [
  { VALUE: "PI", TEXT: "Proforma Invoice" },
  { VALUE: "SI", TEXT: "Sales Invoice" },
];

const requisitionStatus = [
  { VALUE: "W", TEXT: "Waiting" },
  { VALUE: "A", TEXT: "Approved" },
  { VALUE: "C", TEXT: "Cancelled" },
  // { VALUE: null, TEXT: "All" },
];
const billReport = [
  { VALUE: "PB", TEXT: "Purchase Bill" },
  { VALUE: "SB", TEXT: "Service Bill" },
  { VALUE: "SC", TEXT: "Sub Contract" },
  { VALUE: "L", TEXT: "Loan" },
  { VALUE: "PA", TEXT: "Purchase Bill(Additional Charge)" },
  { VALUE: "SA", TEXT: " Service Bill (Additional Charge))" },
];

const billStatus1 = [
  { VALUE: "C", TEXT: "Clearence" },
  { VALUE: "A", TEXT: "Acceptance" },
  { VALUE: "L", TEXT: "LC Date" },
  { VALUE: "B", TEXT: "Bill Date" },
];

const requisitionHistoryStatus = [
  { VALUE: "W", TEXT: "Unapproved" },
  { VALUE: "A", TEXT: "Approved" },
  { VALUE: "D", TEXT: "Denied" },
];

const salesNegotiationType = [
  { VALUE: "N", TEXT: "Negotiation" },
  { VALUE: "L", TEXT: "LC Date" },
  { VALUE: "D", TEXT: "Doc Date" },
];
const salesRealizationType = [
  { VALUE: "R", TEXT: "Realization" },
  { VALUE: "N", TEXT: "Negotiation" },
  { VALUE: "L", TEXT: "LC Date" },
  { VALUE: "D", TEXT: "Doc Date" },
];
const serviceType = [
  { VALUE: "W", TEXT: "Warrenty" },
  { VALUE: "G", TEXT: "General" },
];

const billRegisterType = [
  { VALUE: "B", TEXT: "Bill Date" },
  { VALUE: "R", TEXT: "Rcv Date" },
  { VALUE: "W", TEXT: "Wo Date" },
];

const saleReturnType = [
  { VALUE: "DC", TEXT: "Return Date" },
  { VALUE: "DO", TEXT: "DO Date" },
];

const issueReportType = [
  { VALUE: "S", TEXT: "Summary" },
  { VALUE: "D", TEXT: "Details" },
  { VALUE: "P", TEXT: "Product Issue Report" },
  { VALUE: "MRRR", TEXT: "Material Return Requisition Report" },
  { VALUE: "CR", TEXT: "Consumption Report" },
  { VALUE: "TIR", TEXT: "Transfer Issue Report" },
  { VALUE: "IIR", TEXT: "Internal Issue Report" },
  { VALUE: "CWIR", TEXT: "Code Wise Issue Report" },
];

const dcdoDate = [
  { VALUE: "DC", TEXT: "DC Date" },
  { VALUE: "DO", TEXT: "DO Date" },
];
const percentOn = [
  { VALUE: "", TEXT: "Select" },
  { VALUE: "B", TEXT: "Basic" },
  { VALUE: "G", TEXT: "Gross" },
  { VALUE: "DG", TEXT: "Daily Gross" },
];

const percentOn1003 = [
  { VALUE: "", TEXT: " " },
  { VALUE: "B", TEXT: "Basic" },
  { VALUE: "G", TEXT: "Gross" },
  { VALUE: "DG", TEXT: "Daily Gross" },
];

const lcType = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "L", TEXT: "Local(LC)" },
  { VALUE: "F", TEXT: "Foregin(LC)" },
  { VALUE: "E", TEXT: "EPZ" },
];
const lcType2 = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "LLC", TEXT: "Local(LC)" },
  { VALUE: "FLC", TEXT: "Foregin(LC)" },
  { VALUE: "TT", TEXT: "TT" },
];

const acceptedType = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "AC", TEXT: "Accepted" },
  { VALUE: "NA", TEXT: "Not Accepted" },
];
const acceptType = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: 1, TEXT: "Accept" },
  { VALUE: 0, TEXT: "Unaccept" },
];
const itemMovementType = [
  { VALUE: "F", TEXT: "Fast Moving" },
  { VALUE: "S", TEXT: "Slow Moving" },
  { VALUE: "NS", TEXT: "Not Sale" },
];
const paymentFrequency = [
  { VALUE: "Y", TEXT: "Yearly" },
  { VALUE: "Q", TEXT: "Quarterly" },
  { VALUE: "M", TEXT: "Monthly" },
  { VALUE: "D", TEXT: "Day Basis" },
];

const reply = [
  { VALUE: 0, TEXT: "Reply to sender" },
  { VALUE: 1, TEXT: "Reply to all" },
];

const moreAction = [
  { VALUE: 0, TEXT: "Add star" },
  { VALUE: 1, TEXT: "Remove star" },
  { VALUE: 2, TEXT: "Mark as read" },
  { VALUE: 3, TEXT: "Move to folder" },
  { VALUE: 4, TEXT: "Inbox/ Outbox" },
  { VALUE: 5, TEXT: "Test" },
];

const paymentStatus = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "2", TEXT: "Paid" },
  { VALUE: "3", TEXT: "Pending" },
];
const shipmentEntryStatus = [
  { VALUE: 0, TEXT: "Pending" },
  { VALUE: 1, TEXT: "Clear" },
];

const vmApprovalStatus = [
  { VALUE: "W", TEXT: "Pending" },
  { VALUE: "A", TEXT: "Approved" },
  { VALUE: "R", TEXT: "Rejected" },
];

const vmSeatRequisitionApprovalStatus = [
  { VALUE: "W", TEXT: "Pending" },
  { VALUE: "A", TEXT: "Approved" },
  { VALUE: "H", TEXT: "Declined" },
];

const shipmentEntryReportType = [
  { VALUE: 1, TEXT: "Shipments Bank Guarantee" },
  { VALUE: 2, TEXT: "Shipment Bank Forwarding" },
  { VALUE: 3, TEXT: "Document Acceptance Note" },
  { VALUE: 4, TEXT: "Shipment Endorsement Forwarding" },
];
const issueProcess = [
  { VALUE: 1, TEXT: "On Transaction" },
  { VALUE: 2, TEXT: "On Valuation" },
  { VALUE: 3, TEXT: "Inter Company Sales (On Valuation)" },
  { VALUE: 5, TEXT: "Inter Company Sales (On Policy)" },
  { VALUE: 4, TEXT: "Company Wise Sales Summary" },
  { VALUE: 6, TEXT: "Lot Wise Chemical Consumption" },
  { VALUE: 7, TEXT: "Loan Statement" },
];

const paymentMood = [
  { VALUE: "Cheque", TEXT: "Cheque" },
  { VALUE: "Cash", TEXT: "Cash" },
  { VALUE: "Cash-Cheque", TEXT: "Cash-Cheque" },
];

const salePaymentType = [
  { VALUE: "CS", TEXT: "Cash" },
  { VALUE: "CQ", TEXT: "Cheque" },
  { VALUE: "PO", TEXT: "Pay Order" },
  { VALUE: "AD", TEXT: "Adjustment" },
  { VALUE: "DD", TEXT: "Demand Draft" },
  { VALUE: "CC", TEXT: "Credit Card" },
  { VALUE: "DS", TEXT: "Diposit Slip" },
];

const policyStatus = [
  { VALUE: 0, TEXT: "NO" },
  { VALUE: 1, TEXT: "Jobtitle Special Allow Ded" },
  { VALUE: 2, TEXT: " Bill Policy" },
  { VALUE: 3, TEXT: " Shift Allow " },
  { VALUE: 4, TEXT: "Payable Day" },
];
const policyStatus01 = [
  { VALUE: 0, TEXT: "NO" },
  { VALUE: 1, TEXT: "Jobtitle Special Allow Ded" },
  { VALUE: 2, TEXT: " Bill Policy" },
  { VALUE: 3, TEXT: " Shift Allow " },
];

const reqPaymentType = [
  { VALUE: "CS", TEXT: "Cash" },
  { VALUE: "CQ", TEXT: "Cheque" },
];
const paymentBy = [
  { VALUE: "0", TEXT: "Cheque" },
  { VALUE: "1", TEXT: "Cash" },
  { VALUE: "", TEXT: "Cash-Cheque" },
];
const paymentBy1 = [
  { VALUE: "0", TEXT: "Cheque" },
  { VALUE: "1", TEXT: "Cash" },
  { VALUE: "2", TEXT: "Cash-Cheque" },
];

const probisionData = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "1", TEXT: "Provision" },
  { VALUE: "0", TEXT: "Not Provision" },
];

const bblcDateType = [
  { VALUE: "I", TEXT: "Invoice" },
  { VALUE: "A", TEXT: "Acceptance" },
  { VALUE: "B", TEXT: "Bank Accept DT" },
  { VALUE: "M", TEXT: "Maturity DT" },
];
const auditStatus = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "1", TEXT: "Audited" },
  { VALUE: "0", TEXT: "Unaudited" },
];
const acceptanceType = [
  { VALUE: "Regular", TEXT: "Regular" },
  { VALUE: "Advence", TEXT: "Advence" },
];
const transferType = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "2", TEXT: "Waiting" },
  { VALUE: "1", TEXT: "Approve" },
  { VALUE: "0", TEXT: "Deny" },
];

const transferType1059 = [
  { VALUE: "3", TEXT: "All" },
  { VALUE: "2", TEXT: "Waiting" },
  { VALUE: "1", TEXT: "Approve" },
  { VALUE: "0", TEXT: "Deny" },
];

const transferStatus = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "T", TEXT: "Transfered" },
  { VALUE: "NT", TEXT: "Not Transfered" },
];
const billTypeStatus = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "W", TEXT: "Waiting" },
  { VALUE: "A", TEXT: "Approved" },
  { VALUE: "D", TEXT: "Denied" },
];

const ApproveStatus = [
  { VALUE: null, TEXT: "Select" },
  { VALUE: "W", TEXT: "Waiting" },
  { VALUE: "A", TEXT: "Approved" },
  { VALUE: "D", TEXT: "Denied" },
];

const billType = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "S", TEXT: "Service" },
  { VALUE: "P", TEXT: "Purchase" },
  { VALUE: "L", TEXT: "Loan" },
];

const inBillTypes = [
  { VALUE: "S", TEXT: "Service" },
  { VALUE: "I", TEXT: "Purchase" },
  { VALUE: "L", TEXT: "Loan" },
  { VALUE: "T", TEXT: "Transport-Internal" },
  { VALUE: "SC", TEXT: "Sub Contract" },
  { VALUE: "BI", TEXT: "Insurance" },
  { VALUE: "CF", TEXT: "C&F" },
];

const purchaseBillTypes = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "S", TEXT: "Service" },
  { VALUE: "P", TEXT: "Purchase" },
  { VALUE: "L", TEXT: "Loan" },
  { VALUE: "TI", TEXT: "Transport-Internal" },
  { VALUE: "SC", TEXT: "Sub Contract" },
];

const purchaseBillTypes2 = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "S", TEXT: "Service" },
  { VALUE: "I", TEXT: "Purchase" },
];
const purchaseBillTypes1 = [
  { VALUE: "S", TEXT: "Service" },
  { VALUE: "P", TEXT: "Purchase" },
  { VALUE: "L", TEXT: "Loan" },
  { VALUE: "T", TEXT: "Transport-Internal" },
  { VALUE: "SC", TEXT: "Sub Contract" },
];
const purchaseBillType2 = [
  { VALUE: "S", TEXT: "Service" },
  { VALUE: "I", TEXT: "Purchase" },
  { VALUE: "L", TEXT: "Loan" },
  { VALUE: "T", TEXT: "Transport-Internal" },
  { VALUE: "SC", TEXT: "Sub Contract" },
];

const loanStatus = [
  { VALUE: "IP", TEXT: "Loan Issue Pending" },
  { VALUE: "RP", TEXT: "Loan Receive Pending" },
  { VALUE: "IR", TEXT: "Loan Return Rcv Pending" },
  { VALUE: "IR", TEXT: "Loan Receive Return Pending" },
  { VALUE: "RC", TEXT: "Loan Return & Collected" },
  { VALUE: "LR", TEXT: "Loan Returned" },
  { VALUE: "LC", TEXT: "Loan Collected" },
  { VALUE: "U", TEXT: "Undefined" },
];

const loanTransactionType = [
  { VALUE: "D", TEXT: "Loan Statement details" },
  { VALUE: "L", TEXT: "Loan Reconciliation Statement" },
];
const auditStatusBillPayment = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "A", TEXT: "Audited" },
  { VALUE: "NA", TEXT: "Unaudited" },
];
const recurring = [
  { VALUE: 1, TEXT: "Yes" },
  { VALUE: 0, TEXT: "No" },
  { VALUE: 2, TEXT: "Both" },
];
const attendanceBonusReportType = [
  { VALUE: "0", TEXT: "Details (Bu wise)" },
  { VALUE: "1", TEXT: "Summary" },
  { VALUE: "3", TEXT: "Details" },
  { VALUE: "2", TEXT: "Audit" },
];
const postStatus = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "1", TEXT: "Posting" },
  { VALUE: "0", TEXT: "Not Posting" },
];
const voucherType2 = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "U", TEXT: "Un-Reconciled" },
  { VALUE: "R", TEXT: "Reconciled" },
];
const invoiceType = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "SI", TEXT: "Sl (Local)" },
  { VALUE: "PI", TEXT: "PI (Export)" },
  { VALUE: "CI", TEXT: "CI (Export)" },
];
const invoiceType1 = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "SI", TEXT: "Sl (Local)" },
  { VALUE: "PI", TEXT: "PI (Export)" },
];

const deliveryType = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "DO", TEXT: "DO Wise Delivery" },
  { VALUE: "RP", TEXT: "Replacement Delivery" },
];

const deliveryTypeOne = [
  { VALUE: "DO", TEXT: "DO Wise Delivery" },
  { VALUE: "RP", TEXT: "Replacement Delivery" },
  { VALUE: "SR", TEXT: "Sales Return" },
];

const loanType = [
  { VALUE: "PC", TEXT: "Packing Credit (PC)" },
  { VALUE: "TL", TEXT: "Time Loan" },
];

const orderType = [
  { VALUE: 1, TEXT: "Regular" },
  { VALUE: 2, TEXT: "Commission" },
];
const orderType1 = [
  { VALUE: "BULK", TEXT: "BULK" },
  { VALUE: "SMS", TEXT: "SMS" },
];

const referenceStatus = [
  { VALUE: 1, TEXT: "Active" },
  { VALUE: 3, TEXT: "Closed" },
  { VALUE: 2, TEXT: "Cancel" },
];

const lcBasis = [
  { VALUE: "FOB", TEXT: "FOB" },
  { VALUE: "C & F", TEXT: "C & F" },
  { VALUE: "CIF", TEXT: "CIF" },
  { VALUE: "CM", TEXT: "CM" },
  { VALUE: "CMT", TEXT: "CMT" },
];

const quantityUnitType = [
  { VALUE: 1, TEXT: "Pcs" },
  { VALUE: 12, TEXT: "Dz" },
];
const quantityUnitTypeTwo = [
  { VALUE: 1, TEXT: "Pcs" },
  { VALUE: 2, TEXT: "Set" },
  { VALUE: 12, TEXT: "Dz" },
];

const imageFormateList = {
  JPG: "JPG",
  GIF: "GIF",
  BMP: "BMP",
  TIF: "TIF",
};

const cardGenaratorType = [
  { VALUE: "A", TEXT: "Auto" },
  { VALUE: "E", TEXT: "Numeric Emp ID" },
  { VALUE: "U", TEXT: "User Define" },
];
const genderList = [
  { VALUE: "M", TEXT: "Male" },
  { VALUE: "F", TEXT: "Female" },
];
const genderList3 = [
  { VALUE: null, TEXT: "All" },
  { VALUE: "M", TEXT: "Male" },
  { VALUE: "F", TEXT: "Female" },
];

const applicationNameFormate = [
  { VALUE: "1L", TEXT: "Salutation LName, Fname" },
  { VALUE: "0L", TEXT: "LName, Fname" },
  { VALUE: "1F", TEXT: "Salutation FName Lname" },
  { VALUE: "0F", TEXT: "FName Lname" },
];
const applicationType = [
  { VALUE: "1", TEXT: "Granted" },
  { VALUE: "0", TEXT: "Rejected" },
  { VALUE: "2", TEXT: "Just Apply" },
  { VALUE: "", TEXT: "" },
];
const shipmentMode = [
  { VALUE: "S", TEXT: "Sea" },
  { VALUE: "A", TEXT: "Air" },
  { VALUE: "T", TEXT: "Sea/Air" },
];
const shipmentMode2 = [
  { VALUE: 1, TEXT: "Air" },
  { VALUE: 2, TEXT: "Sea" },
  { VALUE: 3, TEXT: "Air & Sea" },
  { VALUE: 4, TEXT: "Sea & Air" },
  { VALUE: 5, TEXT: "Road" },
];
const shipmentMode3 = [
  { VALUE: 1, TEXT: "Air" },
  { VALUE: 2, TEXT: "Sea" },
  { VALUE: 3, TEXT: "Air & Sea" },
];

const shipType = [
  { VALUE: 1, TEXT: "Direct" },
  { VALUE: 2, TEXT: "Transshipment" },
];
const carierType = [
  { VALUE: "BL", TEXT: "BL No" },
  { VALUE: "AW Bill", TEXT: "MAW Bill No" },
  { VALUE: "TR", TEXT: "TR No" },
  { VALUE: "Courier", TEXT: "Courier No" },
];
const recieveStatus1 = [
  { VALUE: "W", TEXT: "Pending" },
  { VALUE: "P", TEXT: "Partial Receive" },
  { VALUE: "F", TEXT: "Full Receive" },
];

const bainaryType = {
  Yes: 1,
  No: 0,
};
const prefixSuffix = {
  Prefix: "P",
  Suffix: "S",
};

const languageProfieancyStatus = {
  Excellent: "E",
  Moderate: "M",
  Good: "G",
};

const workOrderStatus = {
  All: "",
  Approved: "A",
  Waiting: "W",
};
const workOrderStatusSl = {
  Approved: "A",
  Waiting: "W",
};

const recieveStatus = {
  All: "",
  Pending: "W",
  PartialReceive: "P",
  FullReceive: "F",
};

const approvalStatus = {
  All: "4",
  Complete: "1",
  PartiallyApproved: "2",
  FullPending: "3",
};

const weekStatus = {
  Sunday: 1,
  Monday: 2,
  Tuesday: 3,
  Wednesday: 4,
  Thursday: 5,
  Friday: 6,
  Saturday: 7,
};

const monthStatus = {
  JANUARY: "JAN",
  FEBRUARY: "FEB",
  MARCH: "MAR",
  APRIL: "APR",
  MAY: "MAY",
  JUNE: "JUN",
  JULY: "JUL",
  AUGUST: "AUG",
  SEPTEMBER: "SEP",
  OCTOBER: "OCT",
  NOVEMBER: "NOV",
  DECEMBER: "DEC",
};

const profomaInvoiceType = {
  New: "N",
  Revised: "R",
  Amendment: "A",
  AgnistBlock: "B",
  Canceled: "C",
};

const billStatus2 = {
  New: "N",
  Revised: "R",
  Amendment: "A",
  AgnistBlock: "B",
  AdvancePayment: "AP",
};

const sourceStatus = {
  Nominated: "N",
  OwnSource: "O",
};

const lcTypeThree = {
  Foreign: "F",
  Local: "L",
};
const productItem = {
  Accessories: "A",
  Fabric: "F",
  Machinery: "M",
};

const yearStatus = {
  2005: 2005,
  2006: 2006,
  2007: 2007,
  2008: 2008,
  2009: 2009,
  2010: 2010,
  2011: 2011,
  2012: 2012,
  2013: 2013,
  2014: 2014,
  2015: 2015,
  2016: 2016,
  2017: 2017,
  2018: 2018,
  2019: 2019,
  2020: 2020,
  2021: 2021,
  2022: 2022,
  2023: 2023,
  2024: 2024,
  2025: 2025,
};

const userPermissionType = [
  { VALUE: null, TEXT: "Select" },
  { VALUE: 1, TEXT: "All user" },
  { VALUE: 2, TEXT: "Specific user" },
];

const approvalStatus1 = [
  { VALUE: 1, TEXT: "Complete" },
  { VALUE: 2, TEXT: "Partially Issued" },
  { VALUE: 3, TEXT: "Full Pending" },
];

const taskType = {
  select: "",
  Forward: "F",
  Backward: "B",
  Halt: "H",
};

const sa1046TaskTypeList = [
  { TEXT: "Forward", VALUE: "F" },
  { TEXT: "Backword", VALUE: "B" },
  { TEXT: "Deny", VALUE: "H" },
  { TEXT: "Alternate", VALUE: "A" },
  { TEXT: "Amendment", VALUE: "M" },
];

const dateTypeStatus = [
  { VALUE: "R", TEXT: "Req Date" },
  { VALUE: "W", TEXT: "WO date" },
  { VALUE: "M", TEXT: "MRR Date" },
];

const payrollStatus = [
  { VALUE: 1, TEXT: "Do not create" },
  { VALUE: 2, TEXT: "Create as Jobtitle wise" },
  { VALUE: 3, TEXT: "Create as Employee's current payroll wise" },
];

const promotionPayrollStatus = [
  { VALUE: 1, TEXT: "Do not create" },
  { VALUE: 2, TEXT: "Create as Jobtitle wise" },
  { VALUE: 3, TEXT: "Create as Employee's current payroll wise" },
  { VALUE: 4, TEXT: "Create Payroll with Basic & Gross" },
];

const manPowerStatus = [
  { TEXT: "Section wise Man Power status", VALUE: "S" },
  { TEXT: "Department wise Man Power status", VALUE: "D" },
  { TEXT: "Job Type wise Man Power status", VALUE: "J" },
  { TEXT: "Department && Section Wise Status", VALUE: "DS" },
  { TEXT: "Daily Costing Report", VALUE: "DC" },
];

const manPowerStatusTypeList = [
  { VALUE: "1", TEXT: "Manpower Status" },
  { VALUE: "2", TEXT: "Turnover Status" },
];
const manPowerStatusTypeList1 = [
  { VALUE: 1, TEXT: "Manpower Status" },
  { VALUE: 2, TEXT: "Turnover Status" },
];

const payrollStatus1 = [
  { VALUE: 1, TEXT: "Do not create" },
  { VALUE: 2, TEXT: "Create as Jobtitle wise" },
  { VALUE: 3, TEXT: "Create as Employee's current payroll wise" },
  { VALUE: 4, TEXT: "Create Payroll with Basic&Gross" },
];

const offDayStatyus = [
  { VALUE: 1, TEXT: "SUN" },
  { VALUE: 2, TEXT: "MON" },
  { VALUE: 3, TEXT: "TUE" },
  { VALUE: 4, TEXT: "WED" },
  { VALUE: 5, TEXT: "THU" },
  { VALUE: 6, TEXT: "FRI" },
  { VALUE: 7, TEXT: "SAT" },
];
const applyOn = [
  { VALUE: "B", TEXT: "BASIC" },
  { VALUE: "G", TEXT: "GROSS" },
];
const supplierCategoryList = [
  { VALUE: null, LABEL: "All" },
  { VALUE: 1, LABEL: "Active" },
  { VALUE: 0, LABEL: "In Active" },
];
const statementList = [
  { VALUE: "H", TEXT: "HR Type" },
  { VALUE: "B", TEXT: "Division" },
  { VALUE: "J", TEXT: "Jobtitle" },
  { VALUE: "G", TEXT: "Grade" },
  { VALUE: null, TEXT: "All" },
];
const statementList1 = [
  { VALUE: "H", TEXT: "HR Type" },
  { VALUE: "B", TEXT: "Division" },
  { VALUE: "J", TEXT: "Jobtitle" },
  { VALUE: "G", TEXT: "Grade" },
];
const statementForList = [
  { VALUE: "PF", TEXT: "Provident Fund" },
  { VALUE: "B", TEXT: "Basic" },
  { VALUE: "SA", TEXT: "Salary Advice" },
  { VALUE: "E", TEXT: "Earning" },
  { VALUE: "D", TEXT: "Deduction" },
];
const earningStatusList = [
  { VALUE: "E", TEXT: "Earning" },
  { VALUE: "D", TEXT: "Deduction" },
];
const behaviourStatus = [
  { VALUE: "", TEXT: "Select" },
  { VALUE: "E", TEXT: "Earning" },
  { VALUE: "D", TEXT: "Deduction" },
  { VALUE: "O", TEXT: "Others" },
];
const otherType = [
  { VALUE: null, TEXT: "Select" },
  { VALUE: 2, TEXT: "Present days" },
  { VALUE: 3, TEXT: "Present Hour" },
  { VALUE: 4, TEXT: "Absent Day" },
  { VALUE: 5, TEXT: "Absent Hour" },
  { VALUE: 7, TEXT: "Leave Day" },
  { VALUE: 6, TEXT: "Leave Hour" },
  { VALUE: 10, TEXT: "Holiday" },
  { VALUE: 11, TEXT: "Weekend" },
  { VALUE: 30, TEXT: "OT Rate" },
  { VALUE: 31, TEXT: "OT Hour" },
  { VALUE: 41, TEXT: "Weekend+Offday+Holiday" },
  { VALUE: 43, TEXT: "Weekend+Offday" },
  { VALUE: 42, TEXT: "Total Attendance" },
  { VALUE: 44, TEXT: "Last Day of month" },
];
const behaviorList = [
  { VALUE: "E", TEXT: "Earning" },
  { VALUE: "D", TEXT: "Deduction" },
];
const statementListOne = [
  { VALUE: "M", TEXT: "Monthly Statement" },
  { VALUE: "B", TEXT: "Bank Statement" },
];
const taxBehavior = [
  { VALUE: null, TEXT: "Select" },
  { VALUE: 1, TEXT: "Taxable Element" },
  { VALUE: 0, TEXT: "Non-taxable Element" },
  { VALUE: 2, TEXT: "Income Tax Element" },
];
const clStatusList = [
  { VALUE: null, TEXT: "All" },
  { VALUE: "Shipment", TEXT: "Shipment" },
  { VALUE: "Not Shipment", TEXT: "Not Shipment" },
  { VALUE: "A", TEXT: "Arival Port" },
  { VALUE: "AWNR", TEXT: "Arival Warehouse Not Rcv" },
  { VALUE: "Rcv", TEXT: "Receive" },
  { VALUE: "L", TEXT: "Not Lc" },
];
const docStatusList = [
  { VALUE: null, TEXT: "All" },
  { VALUE: "Paid", TEXT: "Paid" },
  { VALUE: "Unpaid", TEXT: "Unpaid" },
  { VALUE: "Bank Accepted", TEXT: "Bank Accepted" },
  { VALUE: "Accepted", TEXT: "Accepted" },
  { VALUE: "Initialized", TEXT: "Initialized" },
];

const lcReqList = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: 0, TEXT: "WO" },
  { VALUE: 1, TEXT: "L/C" },
];
const lcReqList1 = [
  { VALUE: 0, TEXT: "WO" },
  // { VALUE: 1, TEXT: "L/C" },
];
const itemDestType = [
  { VALUE: "C", TEXT: "Cotton" },
  { VALUE: "L", TEXT: "Lycra" },
];
const purchaseTypeList = [
  { VALUE: "S", TEXT: "Sales Bill Wise" },
  { VALUE: "C", TEXT: "Sales Supplier Wise" },
  { VALUE: "I", TEXT: "Sales Item Wise" },
  { VALUE: "RS", TEXT: "Return Bill Wise" },
  { VALUE: "RC", TEXT: "Return Supplier Wise" },
  { VALUE: "RI", TEXT: "Return Item Wise" },
];
const itemSerialList = [
  { VALUE: "C", TEXT: "Customer Wise" },
  { VALUE: "M", TEXT: "Serial List" },
];
const workOrderStatusTwo = {
  All: "",
  Waiting: "W",
  Approved: "A",
  Denied: "D",
};
const requisitionType = [
  { VALUE: "LI", TEXT: "Loan Issue" },
  { VALUE: "LR", TEXT: "Loan Receive" },
];

const userType = [
  { VALUE: "A", TEXT: "Admin Type" },
  { VALUE: "S", TEXT: "Sales Man Type" },
  { VALUE: "P", TEXT: "POS Type" },
  { VALUE: "C", TEXT: "Audit Type" },
];

const collectionType = [
  { VALUE: 1, TEXT: "Cash" },
  { VALUE: 2, TEXT: "Cheque" },
  { VALUE: 3, TEXT: "Others" },
];

const returnType = [
  { VALUE: "R", TEXT: "Returnable" },
  { VALUE: "NR", TEXT: "Non Returnable" },
];

const salesReportSatus = [
  { VALUE: "SL_2023", TEXT: "Sales Invoice Details WITH Collection" },
  { VALUE: "SL_2025", TEXT: "Delivery Chalan " },
  { VALUE: "SL_20231", TEXT: "Sales Invoice & Delivery Chalan" },
  { VALUE: "SL_2624", TEXT: "Loan" },
  { VALUE: "SL_2241", TEXT: "Packing LIST" },
  { VALUE: "SL_20210", TEXT: "Gate Pass" },
  { VALUE: "SL_20211", TEXT: "Delivery Challan(WITH BATCH Lot)" },
  { VALUE: "SL_20212", TEXT: "Gate Pass (WITH BATCH Lot)" },
  { VALUE: "SL_20213", TEXT: "Delivery Challan(Wastage)" },
  { VALUE: "SL_20214", TEXT: "Gate Pass (Wastage)" },
];

const gradeStatus = {
  Grade: "G",
  Division: "D",
  Class: "C",
  Appeared: "A",
};
const hr1002TrainingType = {
  Local: 1,
  Foreign: 2,
};

const hr1002relationType = {
  Spouse: 1,
  Child: 2,
  Parent: 3,
  Sibling: 4,
  Others: 5,
};

const itemQualityStatus = {
  Good: "Good",
  Damage: "Damage",
  Broken: "Broken",
};
const qcStatus = {
  Accepted: "A",
  "Not Accepted": "N",
};

const statusTwo = {
  All: null,
  Waiting: "W",
  Approved: "A",
  Denied: "D",
};

const statusThree = {
  All: null,
  Pending: "W",
  Approved: "A",
  Rejected: "R",
};

const adjustType = {
  Increase: "I",
  Decrease: "D",
};

const intervalStats = {
  "": "",
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
};
const itemQuality = {
  Serviceable: "Serviceable",
  Unserviceable: "Unserviceable",
};

const secoundRoundingStatus = {
  Trunc: "T",
  Round: "R",
  AsItIs: "A",
  "": "",
};

const adjustWith = {
  InTime: "I",
  OutTime: "O",
  OutTimeBasedOnShiftTime: "OS",
  InTimeBasedOnShiftTime: "IS",
};

const delModeStatus = [
  { VALUE: 1, TEXT: "Air" },
  { VALUE: 2, TEXT: "Sea" },
  { VALUE: 3, TEXT: "Air & Sea" },
  { VALUE: 4, TEXT: "Road" },
];

const currectionType = {
  Holiday: "Holiday",
  Absent: "Absent",
  Leave: "Leave",
  Weekend: "Weekend",
  OffDay: "Off Day",
};

const currectionTypeList = [
  { VALUE: "Holiday", TEXT: "Holiday" },
  { VALUE: "Absent", TEXT: "Absent" },
  { VALUE: "Leave", TEXT: "Leave" },
  { VALUE: "Weekend", TEXT: "Weekend" },
  { VALUE: "Off Day", TEXT: "Off Day" },
];

const workOrderStatus1 = [
  { VALUE: "A", TEXT: "Approved" },
  { VALUE: "W", TEXT: "Waiting" },
];
const procurementStaus = [
  { VALUE: "A", TEXT: "Approved" },
  { VALUE: "W", TEXT: "Pending" },
];
const offDayStatus = [
  { VALUE: 0, TEXT: "Offday" },
  { VALUE: -1, TEXT: "Holiday" },
  { VALUE: 1, TEXT: "Normal" },
];

const printCopyFormat = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "1", TEXT: "Vendor's Copy" },
  { VALUE: "2", TEXT: "Office Copy" },
  { VALUE: "3", TEXT: "Factory Copy" },
];
const printCopyFormat2 = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "1", TEXT: "Vendor's Copy" },
  { VALUE: "2", TEXT: "Office Copy" },
];
const referenceList = [
  { VALUE: "D", TEXT: "Direct" },
  { VALUE: "N", TEXT: "Pur. Notice" },
  { VALUE: "R", TEXT: "Pur. Requisition" },
];
const purchaseOrderTypeList = [
  { VALUE: "S", TEXT: "Summary" },
  { VALUE: "C", TEXT: "Supplier Wise Summary" },
  { VALUE: "L", TEXT: "Customer Wise Detail" },
  { VALUE: "I", TEXT: "Item Wise" },
  { VALUE: "D", TEXT: "Form" },
];
const purchaseOrderStatusList = [
  { VALUE: "X", TEXT: "All but Denied" },
  { VALUE: "A", TEXT: "Approved" },
  { VALUE: "W", TEXT: "Waiting" },
  { VALUE: "D", TEXT: "Denied" },
  { VALUE: "P", TEXT: "Processing" },
];
const purchaseRequisitionTypeList = [
  { VALUE: "F", TEXT: "Form Type" },
  { VALUE: "R", TEXT: "Requisition Wise Detail" },
  { VALUE: "I", TEXT: "Item wise Detail" },
];
const purchaseRequisitionStatusList = [
  { VALUE: null, TEXT: "All" },
  { VALUE: "A", TEXT: "Approved" },
  { VALUE: "W", TEXT: "Waiting" },
  { VALUE: "C", TEXT: "Cancelled" },
];
const manpowerStrengthReqApprovalStatusList = [
  { VALUE: null, TEXT: "All" },
  { VALUE: "A", TEXT: "Approved" },
  { VALUE: "W", TEXT: "Waiting" },
  { VALUE: "D", TEXT: "Denied" },
];
const invoiceStatus = [
  { VALUE: "A", TEXT: "Approved" },
  { VALUE: "W", TEXT: "Waiting" },
  { VALUE: "D", TEXT: "Denied" },
];

const approvalLayerStatus = [
  { VALUE: "W", TEXT: "Not Approve" },
  { VALUE: "A", TEXT: "Approved" },
  { VALUE: "D", TEXT: "Denied" },
];

const transactionStatus = [
  { VALUE: "1", TEXT: " Contract Wise Other Invoices" },
  { VALUE: "2", TEXT: "Workorder Wise Other Invoices" },
  { VALUE: "3", TEXT: "Bill Wise" },
];

const purchaseTransactionSummaryList = [
  { VALUE: "S", TEXT: "Purchase MRR Wise" },
  { VALUE: "C", TEXT: "Purchase Supplier Wise" },
  // { VALUE: "I", TEXT: "Purchase Item Wise" },
  // { VALUE: "SD", TEXT: "Purchase MRR Wise Purchase Detail" },
  // { VALUE: "RS", TEXT: "Return MRR Wise" },
  // { VALUE: "RC", TEXT: "Return Supplier Wise" },
  // { VALUE: "RI", TEXT: "Return Item Wise" },
];
const budgetTypeList = [
  { VALUE: "NO", TEXT: "No Budget" },
  { VALUE: "FI", TEXT: "Financial Budget" },
  { VALUE: "PA", TEXT: "Purchase Budget" },
];

const financialStatementType = [
  { VALUE: "B", TEXT: "Balance Sheet" },
  { VALUE: "I", TEXT: "Income Statement" },
  { VALUE: "C", TEXT: "Cost of Good Sold" },
  { VALUE: "CI", TEXT: "Cash Flow Indirect" },
  { VALUE: "OS", TEXT: "Overhead Statement" },
  { VALUE: "R", TEXT: "Retained Earnings" },
  { VALUE: "SC", TEXT: "Share Capital" },
  { VALUE: "OI", TEXT: "Operating Income" },
];
const isBudgetList = [
  { VALUE: 0, TEXT: "No Budget" },
  { VALUE: 1, TEXT: "Only Message" },
  { VALUE: 2, TEXT: " Message & Protect" },
];
const csReprotTypeList = [
  { VALUE: 0, TEXT: "Group / Item Wise" },
  { VALUE: 1, TEXT: "Item And TS Wise" },
  { VALUE: 2, TEXT: "Item Wise" },
  { VALUE: 3, TEXT: "Unit Wise" },
  { VALUE: 4, TEXT: "Department Wise" },
  { VALUE: 5, TEXT: "Requsitior Wise" },
  { VALUE: 6, TEXT: "Procurer Wise" },
  { VALUE: 7, TEXT: "Supplier Wise" },
];
const bankTypeList = [
  { VALUE: 1, TEXT: "One Bank" },
  { VALUE: 2, TEXT: "Islami Bank" },
  { VALUE: 3, TEXT: "Bank Asia" },
  { VALUE: 4, TEXT: "Prime Bank" },
];
const importReportTypeList = [
  { VALUE: 1, TEXT: "Bank Forwarding Application" },
  { VALUE: 2, TEXT: "Application & Aggrement Form" },
  { VALUE: 3, TEXT: "LC Authorisation Form" },
];
const purchaseAnalysisTypeList = [
  { VALUE: "M", TEXT: "Work Order Wise Details Report" },
];
const transactionRelatedTo = [
  { VALUE: 1, TEXT: "Work Order" },
  { VALUE: 2, TEXT: "Cash" },
  { VALUE: 3, TEXT: "Purchase Contract" },
  { VALUE: 4, TEXT: "Purchase Requisition" },
  { VALUE: 0, TEXT: "None" },
  { VALUE: null, TEXT: "All" },
];

const transactionRelatedToSl = [
  { VALUE: 1, TEXT: "Delivery Order" },
  { VALUE: 2, TEXT: "Sales Contract" },
  { VALUE: 3, TEXT: "Sales Invoice" },
  { VALUE: 4, TEXT: "POS" },
  { VALUE: 0, TEXT: "None" },
  { VALUE: null, TEXT: "All" },
];
const importLeaveTypeList = [
  { VALUE: 1, TEXT: "Leave Register" },
  { VALUE: 2, TEXT: "Leave Register Detail" },
  { VALUE: 3, TEXT: "Leave Opening Balance" },
  { VALUE: 4, TEXT: "Earn Leave From Present" },
  { VALUE: 5, TEXT: "Earn Leave Payment" },
  { VALUE: 6, TEXT: "Summery" },
];
const summeryTypeList = [
  { VALUE: 0, TEXT: "Normal" },
  { VALUE: 1, TEXT: "Group" },
];

const reportEmpList = [{ VALUE: 1, TEXT: "Emp List (Process wise)" }];
const loanHistoryReportType = [
  { VALUE: "S", TEXT: "Summary" },
  { VALUE: "D", TEXT: "Details" },
  { VALUE: "L", TEXT: "List" },
];
const salaryTypeList = [
  { VALUE: "TD", TEXT: "Time/Day Rated" },
  { VALUE: "P", TEXT: "Piece Rated" },
];
const importLcReportTypeList = [
  { VALUE: 1, TEXT: "LC Reports" },
  { VALUE: 2, TEXT: "LC Supplier wise Reports" },
  { VALUE: 3, TEXT: "LC Statement Report" },
];
const documentWisePurchaseStatementType = [
  { VALUE: "S", TEXT: "LC Summary" },
  { VALUE: "D", TEXT: "Document Wise" },
  { VALUE: "L", TEXT: "LC Report" },
];
const handoverTransportType = [
  { VALUE: 0, TEXT: "Handover Transport Report" },
  { VALUE: 1, TEXT: "CNF Agency Commission Bill" },
];

const acceptedType2 = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "A", TEXT: "Accepted" },
  { VALUE: "NA", TEXT: "Not Accepted" },
];

const dateStatus = [
  { VALUE: "1", TEXT: "Requisition Date" },
  { VALUE: "2", TEXT: "Expected Date" },
  { VALUE: "3", TEXT: "Approve Date" },
];
const reqStatus = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: 1, TEXT: "Complete" },
  { VALUE: 2, TEXT: "Partially Issue" },
  { VALUE: 3, TEXT: "Full Pending" },
];

const moneyReqStatus = [
  { VALUE: "W", TEXT: "Pending" },
  { VALUE: "A", TEXT: "Passed" },
  { VALUE: "H", TEXT: "Denied" },
];

const attendaceList = [
  { VALUE: 1, TEXT: "With Time (In / Out)" },
  { VALUE: 2, TEXT: "Without Time (In / Out)" },
  { VALUE: 3, TEXT: "With Movement" },
  { VALUE: 4, TEXT: "Without Date" },
  { VALUE: 5, TEXT: "With Late Duration" },
  { VALUE: 6, TEXT: "Absent List" },
  { VALUE: 7, TEXT: "Holiday Absent" },
  { VALUE: 8, TEXT: "With Time (In / Out) [BU Group]" },
  { VALUE: 9, TEXT: "Absent Comparison (Two Days)" },
  { VALUE: 10, TEXT: "Inactive Employee Card Punch" },
  { VALUE: 11, TEXT: "With Time (C)" },
];

const incrementSuggestionReportFormetType = [
  { VALUE: "HR_3081", TEXT: "Format 1" },
  { VALUE: "", TEXT: "Format 2" },
  { VALUE: "HR_3084", TEXT: "Incremented List" },
  { VALUE: "HR_3085", TEXT: "Increment List (Gross)" },
  { VALUE: "HR_3086", TEXT: "Increment Letter" },
  { VALUE: "HR_3087", TEXT: "Format 3" },
  { VALUE: "HR_3088", TEXT: "Format 4" },
];
const incrementSuggestionReportCheckType = [
  { VALUE: 0, TEXT: "Increment Holder Only" },
  { VALUE: 1, TEXT: "Incremet Not Found" },
  { VALUE: null, TEXT: "All" },
];
const incrementSuggestionActiveStatus = [
  { VALUE: null, TEXT: "All" },
  { VALUE: 1, TEXT: "Active" },
  { VALUE: 0, TEXT: "Inactive" },
];

const activeStatusIn1013 = [
  { VALUE: null, TEXT: "All" },
  { VALUE: 1, TEXT: "Active" },
  { VALUE: 0, TEXT: "Inactive" },
];
// Active
// Canceled
// Sattled

const loanRegStatus = [
  { VALUE: "A", TEXT: "Active" },
  { VALUE: "C", TEXT: "Canceled" },
  { VALUE: "S", TEXT: "Sattled" },
];
const activeStatusCurrentMonth = [
  { VALUE: null, TEXT: "All" },
  { VALUE: 1, TEXT: "Active" },
  { VALUE: 0, TEXT: "Inactive" },
  { VALUE: 2, TEXT: "Inactive(Current Month)" },
];
const earnLeavePaymentReportFormat = [
  { VALUE: 1, TEXT: "Format 1" },
  { VALUE: 2, TEXT: "Format 2" },
  { VALUE: 3, TEXT: "Format 3" },
];
const transactionAction = [
  { VALUE: null, TEXT: "All" },
  { VALUE: "IR", TEXT: "Receive (+)" },
  { VALUE: "II", TEXT: "Issue (-)" },
];

const transactionActionPur = [
  { VALUE: null, TEXT: "All" },
  { VALUE: "PR", TEXT: "Receive (+)" },
  { VALUE: "PI", TEXT: "Issue (-)" },
];

const transactionActionSl = [
  { VALUE: null, TEXT: "All" },
  { VALUE: "SR", TEXT: "Receive (+)" },
  { VALUE: "SI", TEXT: "Issue (-)" },
];

const earnLeavePaymentReportType = [
  { VALUE: 0, TEXT: "Details" },
  { VALUE: 1, TEXT: "Summary" },
  { VALUE: 2, TEXT: "Leave Register Detail" },
  { VALUE: 3, TEXT: "Leave Register Summary" },
];
const absentConterList = [
  { VALUE: 1, TEXT: "On Total Absent" },
  { VALUE: 2, TEXT: "On Continuous Absent" },
];
const absentConterList1 = [
  { VALUE: "1", TEXT: "On Total Absent" },
  { VALUE: "2", TEXT: "On Continuous Absent" },
];
const dailyStatusList = [
  { VALUE: "P", TEXT: "Present" },
  { VALUE: "A", TEXT: "Absent" },
  { VALUE: "H", TEXT: "Holiday" },
  { VALUE: "W", TEXT: "Weekly" },
  { VALUE: "L", TEXT: "Late In" },
  { VALUE: "E", TEXT: "Early Exit" },
  { VALUE: "L/E", TEXT: "Late/Early" },
  { VALUE: "HP", TEXT: "Holiday Present" },
  { VALUE: "WP", TEXT: "Weekly Present" },
  { VALUE: "OP", TEXT: "Offday Present" },
  { VALUE: "No", TEXT: "Present but no Outtime" },
  { VALUE: "OT", TEXT: "OT Only" },
  //  { VALUE: null, TEXT: "All" },
];
const EmployeeStatusList = [
  { VALUE: "Present", TEXT: "Present" },
  { VALUE: "Weekend", TEXT: "Weekend" },
  { VALUE: "Absent", TEXT: "Absent" },
  { VALUE: "Holiday", TEXT: "Holiday" },
  { VALUE: "Off Day", TEXT: "Off Day" },
  { VALUE: "Present : Inside", TEXT: "Present : Inside" },
  { VALUE: "EE", TEXT: "Early Exit" },
  { VALUE: "LE", TEXT: "Late Entry" },
];

const activeStatusCom = [
  { VALUE: 1, TEXT: "Active" },
  { VALUE: 0, TEXT: "Inactive" },
  { VALUE: null, TEXT: "All" },
];
const activeStatusCom1 = [
  { VALUE: 1, TEXT: "Active" },
  { VALUE: 0, TEXT: "Inactive" },
];

const activeStatusVm = [
  { VALUE: "Active", TEXT: "Active" },
  { VALUE: "Inactive", TEXT: "Inactive" },
];

const vmSaetAllocationStatus = [
  { VALUE: "W", TEXT: "Pending" },
  { VALUE: "A", TEXT: "Allocated" },
];

const employeeWiseAttendaceReportFormetDefault = [
  { VALUE: "HR_2029", TEXT: "Format 1 (Default)" },
  { VALUE: "HR_2024", TEXT: "Format 2" },
  { VALUE: "HR_20212", TEXT: "Format 1 (Default 2)" },
  { VALUE: "HR_20214", TEXT: "Format 1 (Default 3 - alt)" },
  { VALUE: "HR_20215", TEXT: "Format 1 (Default - Alt)" },
  { VALUE: "HR_20218", TEXT: "Format 1" },
  { VALUE: "HR_20219", TEXT: "Format 2(Default-Alt)" },
  { VALUE: "HR_20220", TEXT: "Format 1(Default-1 Non Production)" },
  { VALUE: "HR_20221", TEXT: "Format 4" },
  { VALUE: "HR_2024", TEXT: "Format 01 (Default)" },
  { VALUE: "HR_2026", TEXT: "Format 0101" },
  { VALUE: "HR_2027", TEXT: "Format 1 (3)" },
];

const employeeWiseAttendaceReportFormetSummary = [
  { VALUE: "HR_2026", TEXT: "Format 1 (Default)" },
  { VALUE: "HR_20210", TEXT: "Format 2" },
  { VALUE: "HR_20213", TEXT: "Format 3(six)" },
  { VALUE: "HR_20216", TEXT: "Format 3 (Point System)" },
  { VALUE: "HR_20222", TEXT: "Format 4" },
];

const employeeWiseAttendaceType = [
  { VALUE: 1, TEXT: "Without Date" },
  { VALUE: 2, TEXT: "With Date" },
  { VALUE: 3, TEXT: "Without Shift" },
];

const employeeWiseAttendaceReportType = [
  { VALUE: 1, TEXT: "Online Date" },
  { VALUE: 2, TEXT: "Last Process" },
];

const recieveLoanAmt = [
  { VALUE: 1, TEXT: "Yes" },
  { VALUE: 0, TEXT: "No" },
  { VALUE: 6, TEXT: "Missed" },
  { VALUE: 5, TEXT: "Forward to PRL" },
  { VALUE: 4, TEXT: "Manual Return" },
  { VALUE: 2, TEXT: "Forward" },
  { VALUE: 3, TEXT: "Forward to Next Loan" },
];

const collectionTypeHr1007 = [
  { VALUE: 1, TEXT: "Cash" },
  { VALUE: 2, TEXT: "Cheque" },
];

const calOn = [
  { VALUE: "H", TEXT: "Hour" },
  { VALUE: "T", TEXT: "Time" },
];
const calOn2 = [
  { VALUE: "H", TEXT: "Hour" },
  { VALUE: "D", TEXT: "Day" },
];
const incrementTYpe = [{ VALUE: "I", TEXT: "Increment" }];

const calOn01 = [
  { VALUE: "H", TEXT: "Hour" },
  { VALUE: "T", TEXT: "Time" },
  { VALUE: "HS", TEXT: "Salary" },
  { VALUE: "D", TEXT: "Day" },
  { VALUE: "D", TEXT: "Day" },
];

const formulaOn = [
  { VALUE: "B", TEXT: "Basic" },
  { VALUE: "G", TEXT: "Gross" },
];
const rateType = [
  { VALUE: "D", TEXT: "Division" },
  { VALUE: "M", TEXT: "Multiply" },
  // { VALUE: "M", TEXT: "Multiply" },
];
const rateType2 = [
  { VALUE: "D", TEXT: "Division" },
  { VALUE: "M", TEXT: "Multiply" },
  { VALUE: "F", TEXT: "Fixed" },
  // { VALUE: "M", TEXT: "Multiply" },
];

const maxAmtBy = [
  { VALUE: "B", TEXT: "Basic" },
  { VALUE: "G", TEXT: "Gross" },
  { VALUE: "F", TEXT: "Fixed" },
];

const typeList = [
  { VALUE: "F", TEXT: "Forward" },
  { VALUE: "B", TEXT: "Backword" },
  { VALUE: "H", TEXT: "Deny" },
  { VALUE: "A", TEXT: "Alternate" },
];
const calDayType = [
  { VALUE: "PM", TEXT: "Present(M)" },
  { VALUE: "PD", TEXT: "Present(D)" },
  { VALUE: "D", TEXT: "Day" },
  { VALUE: "R", TEXT: "Rate" },
  { VALUE: "PAM", TEXT: "Payable(M)" },
];

const lateDayType = [
  { VALUE: "I", TEXT: "Interval" },
  { VALUE: "R", TEXT: "Range" },
  { VALUE: "M", TEXT: "Minute" },
];

const moduleList = [
  { VALUE: "AC", TEXT: "Accounts" },
  { VALUE: "SL", TEXT: "Sales" },
  { VALUE: "IN", TEXT: "Inventory" },
  { VALUE: "PR", TEXT: "Purchase" },
  { VALUE: "HR", TEXT: "Human Resource" },
];

const searchArea = [
  { VALUE: 1, TEXT: "Employee" },
  { VALUE: 0, TEXT: "Bonus Hold" },
];

const supplierAccount = [
  //{ VALUE: 1, TEXT: "null" },
  { VALUE: 2, TEXT: "Mapped" },
  { VALUE: 0, TEXT: "Not Mapped" },
];

const amountStatus = [
  { VALUE: ">=", TEXT: ">=" },
  { VALUE: "<=", TEXT: "<=" },
  { VALUE: ">", TEXT: ">" },
  { VALUE: "<", TEXT: "<" },
  { VALUE: "=", TEXT: "=" },
];

const dailyOrMonthly = [
  { VALUE: "D", TEXT: "Daily" },
  { VALUE: "M", TEXT: "Monthly" },
];
const calNoOption = [
  { VALUE: "T", TEXT: "Time" },
  { VALUE: "H", TEXT: "Hour" },
];
const durationYear = [
  { VALUE: "=", TEXT: "=" },
  { VALUE: ">", TEXT: ">" },
  { VALUE: "<", TEXT: "<" },
  { VALUE: ">=", TEXT: ">=" },
  { VALUE: "<=", TEXT: "<=" },
];
const durationMonth = [
  { VALUE: "=", TEXT: "=" },
  { VALUE: ">", TEXT: ">" },
  { VALUE: ">=", TEXT: ">=" },
  { VALUE: "<", TEXT: "<" },
];
const durationDay = [
  { VALUE: "=", TEXT: "=" },
  { VALUE: ">", TEXT: ">" },
];
const durationYearOperator = [
  { VALUE: "=", TEXT: "=" },
  { VALUE: "%3E", TEXT: ">" },
  { VALUE: "%3C", TEXT: "<" },
  { VALUE: "%3E=", TEXT: ">=" },
  { VALUE: "%3C=", TEXT: "<=" },
];
const durationMonthOperator = [
  { VALUE: "=", TEXT: "=" },
  { VALUE: "%3E", TEXT: ">" },
  { VALUE: "%3C", TEXT: "<" },
  { VALUE: "%3E=", TEXT: ">=" },
];
const durationDayOperator = [
  { VALUE: "=", TEXT: "=" },
  { VALUE: "%3E", TEXT: ">" },
];

const approveStatus = [
  { VALUE: null, TEXT: "All" },
  { VALUE: "2", TEXT: "Submit" },
  { VALUE: "1", TEXT: "Draft" },
  { VALUE: "3", TEXT: "Approved" },
  { VALUE: "4", TEXT: "Paid" },
];
const grossStatus = [
  { VALUE: 0, TEXT: "Without Gross" },
  { VALUE: 1, TEXT: "With Gross" },
];
const salPayMood = [
  { VALUE: "C", TEXT: "Cash" },
  { VALUE: "Q", TEXT: "Cheque" },
];
const employeeListReport = [
  { VALUE: 0, TEXT: "Employee Details" },
  { VALUE: 1, TEXT: "Employee List" },
  { VALUE: 2, TEXT: "Employee List Group 3" },
  { VALUE: 4, TEXT: "Summary" },
  { VALUE: 5, TEXT: "Absent & Leave Days" },
  { VALUE: 6, TEXT: "New Employee" },
  { VALUE: 7, TEXT: "New Emp(Format-1)" },
  { VALUE: 8, TEXT: "New Emp(Format-2)" },
  { VALUE: 9, TEXT: "Employee Evaluation" },
  { VALUE: 10, TEXT: "Emp List With Gross" },
  { VALUE: 11, TEXT: "Emp List (Process wise)" },
  { VALUE: 12, TEXT: "Emp List with Payroll" },
];

const employeeListReportOne = [
  { VALUE: 0, TEXT: "Employee List" },
  { VALUE: 1, TEXT: "Suggestion List" },
];

const payScheduleStatus = [
  { VALUE: 1, TEXT: "Schedule Complete" },
  { VALUE: 0, TEXT: "Waiting For Schedule" },
];

const paymentMode = [
  { VALUE: "Cheque", TEXT: "Cheque" },
  { VALUE: "Cash", TEXT: "Cash" },
  { VALUE: "Cash-Cheque", TEXT: "Cash Cheque" },
];
const paymentMode1 = [
  { VALUE: "LC", TEXT: "LC" },
  { VALUE: "FDD", TEXT: "FDD" },
  { VALUE: "FTT", TEXT: "FTT" },
  { VALUE: "CREDIT", TEXT: "CREDIT" },
  { VALUE: "FOC", TEXT: "FOC" },
];
const salaryType = [
  { VALUE: "TD", TEXT: "Time/Day Rated" },
  { VALUE: "P", TEXT: "Piece Rated" },
];
const purposeTypeList = [
  { VALUE: null, TEXT: "All" },
  { VALUE: "P", TEXT: "Personal" },
  { VALUE: "O", TEXT: "Offical" },
];
const purposeTypeList1 = [
  { VALUE: "P", TEXT: "Personal" },
  { VALUE: "O", TEXT: "Offical" },
];
const departmentList = [
  { VALUE: "S", TEXT: "Section" },
  { VALUE: "D", TEXT: "Department" },
  { VALUE: "A", TEXT: "At a galance" },
  { VALUE: "HR_2228", TEXT: "TOP SHEET (BU wise)" },
  { VALUE: "HR_2229", TEXT: "TOP SHEET (Jobtitle wise)" },
  { VALUE: "HR_22210", TEXT: "TOP SHEET (Company wise)" },
  { VALUE: "HR_22211", TEXT: "TOP SHEET (BU wise - Non Com)" },
  { VALUE: "HR_22212", TEXT: "Balance Overtime Summary" },
  { VALUE: "HR_22213", TEXT: "TOP SHEET (BU wise- Format 12)" },
  { VALUE: "HR_22214", TEXT: "Balance Overtime Summary(Format 2)" },
  { VALUE: "HR_22215", TEXT: "BU Wise Present Summary" },
  { VALUE: "HR_22216", TEXT: "TOP SHEET (Cash & Bank)" },
  { VALUE: "HR_22217", TEXT: "Salary Comparison" },
  { VALUE: "HR_22218", TEXT: "TOP SHEET (BU Group wise)" },
  { VALUE: "HR_22219", TEXT: "BU WISE TABULAR SHEET (F-13)" },
  { VALUE: "HR_22221", TEXT: "With Distribution policy" },
  { VALUE: "HR_22220", TEXT: "Non com & OT Dist" },
  { VALUE: "HR_22222", TEXT: "Top Sheet (3 Segment OT)" },
  { VALUE: "HR_22223", TEXT: "Balance Overtime Summary (Format 3)" },
  { VALUE: "HR_22224", TEXT: "Top Sheet (Format 9 -Fixed)" },
  { VALUE: "HR_22225", TEXT: "Extra OT Summary Sheet (2 Hour)" },
  {
    VALUE: "HR_22226",
    TEXT: "Balance OT & Total Salary Payment Sheet Summary",
  },
  { VALUE: "HR_22227", TEXT: "Extra OT Summary Sheet (1 hour)" },
];
const overTimeRequisitionType = [
  { VALUE: 1, TEXT: "Over Time Requisition" },
  { VALUE: 2, TEXT: "Over Time Requisition Summary" },
];
const overtimeRateList = [
  { VALUE: "0", TEXT: "Time Rated" },
  { VALUE: "1", TEXT: "Piece Rated" },
  { VALUE: null, TEXT: "All" },
];
const otType = [
  { VALUE: 1, TEXT: "Extra OT" },
  { VALUE: 2, TEXT: "General OT" },
];
const tiffinType = [
  { VALUE: 1, TEXT: "Worker" },
  { VALUE: 2, TEXT: "Executive" },
  { VALUE: 3, TEXT: "Prod Staff" },
];
const overTimeRequisitionReportFormat = [
  { VALUE: 1, TEXT: "Format-1" },
  { VALUE: 2, TEXT: "Format-2" },
  { VALUE: 3, TEXT: "Format-3" },
];
const equisitionReportFormat = [
  { VALUE: 1, TEXT: "Format-1" },
  { VALUE: 2, TEXT: "Format-2" },
  { VALUE: 3, TEXT: "Format-3" },
  { VALUE: 4, TEXT: "Format-4" },
];
const issueAs = [
  { VALUE: "A", TEXT: "All" },
  { VALUE: "C", TEXT: "Issue as Capital Item" },
  { VALUE: "R", TEXT: "Issue as Revenue Item" },
];
const overTimeRequisitionReportFormat2 = [
  { VALUE: 1, TEXT: "Format-1" },
  { VALUE: 2, TEXT: "Format-2" },
];
const leaveRegisterHistoryReportType = [
  { VALUE: "HR_3002", TEXT: "Section" },
  { VALUE: "HR_3003", TEXT: "Jobtitle" },
  { VALUE: "HR_3001", TEXT: "Employee" },
  { VALUE: "HR_3004", TEXT: "ML" },
];
const activeStatusLeaveRegisterHistory = [
  { VALUE: null, TEXT: "All" },
  { VALUE: 1, TEXT: "Active" },
  { VALUE: 0, TEXT: "In-Active" },
];
const activeStatusLeaveRegisterHistory1 = [
  { VALUE: 1, TEXT: "Active" },
  { VALUE: 0, TEXT: "In-Active" },
];
const trainingStatus = [
  { VALUE: 0, TEXT: "Without Training" },
  { VALUE: 1, TEXT: "Trained" },
];

const finalSettlementStatementReportType = [
  { VALUE: "S", TEXT: "Statement" },
  { VALUE: "L", TEXT: "List" },
  { VALUE: "W", TEXT: "Sattlement List" },
  { VALUE: "G", TEXT: "Statement List with Basic and Gross" },
];
const requisitiontype1284 = [
  { VALUE: "T", TEXT: "Transfer Requisition" },
  // { VALUE: "L", TEXT: "Loan Requisition" },
];
const requisitiontype1310 = [{ VALUE: "L", TEXT: "Loan Requisition" }];

const billPaymentReportType = [
  { VALUE: "HR_2251", TEXT: "Bill Payment Detail" },
  { VALUE: "HR_2252", TEXT: "Bill Payment Summary" },
  { VALUE: "HR_2253", TEXT: "Night Allowance details" },
];
const billPaymentPayableStatus = [
  { VALUE: -1, TEXT: "All Employee" },
  { VALUE: 0, TEXT: "Payable Only" },
];
const salesTransactionType = [
  { TEXT: "Challan Wise (Sales)", VALUE: "S" },
  { TEXT: "Customer Wise (Sales)", VALUE: "C" },
  { TEXT: "Item Wise (Sales)", VALUE: "I" },
  { TEXT: "Challan Wise (Return)", VALUE: "RS" },
  { TEXT: "Customer Wise (Return)", VALUE: "RC" },
  { TEXT: "Item Wise (Return)", VALUE: "RI" },
];
const companyType = [
  { VALUE: null, TEXT: "All" },
  { VALUE: 1, TEXT: "Internal" },
  { VALUE: 2, TEXT: "Extarnal" },
];
const gatePassType = [
  { VALUE: null, TEXT: "All" },
  { VALUE: 2, TEXT: "Returnable" },
  { VALUE: 1, TEXT: "Non Returnable" },
];

const loanReportType = [
  { VALUE: "D", TEXT: "Loan Order Preview" },
  { VALUE: "E", TEXT: "Loan Oder" },
];
const paymentCompleteStatus = [
  { VALUE: null, TEXT: "All" },
  { VALUE: 2, TEXT: "Pending" },
  { VALUE: 1, TEXT: "Complete" },
];
const paymentStatusPaySalary = [
  { VALUE: 1, TEXT: "Paid" },
  { VALUE: 0, TEXT: "Unpaid" },
  { VALUE: null, TEXT: "All" },
];
const paymentStatusPaySalary1 = [
  { VALUE: 1, TEXT: "Paid" },
  { VALUE: 0, TEXT: "Unpaid" },
];
const employeeSalaryStatus = [
  { VALUE: 1, TEXT: "With Pay" },
  { VALUE: 0, TEXT: "Without Pay" },
  { VALUE: null, TEXT: "All" },
];
const employeeSalaryStatus1 = [
  { VALUE: 1, TEXT: "With Pay" },
  { VALUE: 0, TEXT: "Without Pay" },
];
const reportTitleForPaySalary = [
  { VALUE: "11.69x8.27", TEXT: "A4" },
  { VALUE: "14x8.5", TEXT: "Legal" },
  { VALUE: "11x8.5", TEXT: "Letter" },
  { VALUE: "14x11", TEXT: "Fanfold(14x11)" },
  { VALUE: "15x8.5", TEXT: "Width '15' x Height '8.5'" },
  { VALUE: "16x8.5", TEXT: "Width '16' x Height '8.5'" },
  { VALUE: "17x8.5", TEXT: "Width '17' x Height '8.5'" },
  { VALUE: "10.5x8.27", TEXT: "'10.5x8.27'" },
];
const testReportPriceType = [
  { VALUE: "SL_2891", TEXT: "Local Price" },
  { VALUE: "SL_2892", TEXT: "Import Price" },
];
const salesReportType = [
  { VALUE: "SL_2831", TEXT: "Sales" },
  { VALUE: "SL_2833", TEXT: "Collection" },
  { VALUE: "SL_2832", TEXT: "Total Internal Sales Report" },
  { VALUE: "SL_2837", TEXT: "Total Local Sales Report" },
  { VALUE: "SL_2834", TEXT: "Net Cash Sales Report" },
  { VALUE: "SL_2835", TEXT: "Net Loan Sales Report" },
  { VALUE: "SL_2836", TEXT: "Net Credit Sales Report" },
];
const loanReqType = [
  { VALUE: null, TEXT: "ALL" },
  { VALUE: "LR", TEXT: "LOAN Receive" },
  { VALUE: "LI", TEXT: "Loan Issue" },
];
const activeStatusThree = [
  { VALUE: null, TEXT: "All" },
  { VALUE: 0, TEXT: "Active" },
  { VALUE: 1, TEXT: "Cancelled" },
];
const processedStatus = [
  { VALUE: "P", TEXT: "Processed" },
  { VALUE: "V", TEXT: "Void" },
];

const transferIssue = [{ VALUE: "IN_29110", TEXT: "Transfer Issue" }];

const paymentType = [
  { VALUE: "L", TEXT: "Lc at Sight" },
  { VALUE: "D", TEXT: "Deffered LC" },
  { VALUE: "T", TEXT: "T/T" },
  { VALUE: "U", TEXT: "UPAS" },
];
const inPaymentType = [
  { VALUE: "CH", TEXT: "Cash" },
  { VALUE: "LC", TEXT: "LC" },
  { VALUE: "CR", TEXT: "Credit Sale" },
  { VALUE: "LN", TEXT: "Loan Sale" },
  { VALUE: "GT", TEXT: "Gift" },
  { VALUE: "BL", TEXT: "Bill" },
  { VALUE: "W", TEXT: "Without Type" },
];
const stockTypeList = [
  { VALUE: "1", TEXT: "Inventory Valuation Summary" },
  { VALUE: "2", TEXT: "Inventory Stock Status" },
];

const pendingLcDateOptions = [
  { VALUE: "F", TEXT: "Fixed Date" },
  { VALUE: "P", TEXT: "Periodical" },
];

const statusListHR1197 = [
  { VALUE: "W", TEXT: "Pending" },
  { VALUE: "A", TEXT: "Completed" },
];

const marketingSalesReportType = [
  { VALUE: "SL_2191", TEXT: "Sales And Collection Report" },
  { VALUE: "SL_2193", TEXT: "Sales Report Without Loan" },
  { VALUE: "SL_2192", TEXT: "Item Sales (Without Inter com)" },
  { VALUE: "SL_2197", TEXT: "Item Sales ( Inter company)" },
  { VALUE: "SL_2196", TEXT: "Loan Report" },
  { VALUE: "SL_2198", TEXT: "Detail Marketing Report" },
  { VALUE: "SL_21911", TEXT: "Customer Wise Sale" },
];
const receivableLedgerReportType = [
  { VALUE: "SL_2041", TEXT: "Receivable Ledger" },
  { VALUE: "SL_2042", TEXT: "Document wise Receivable Ledger" },
];
const yesOrNo = [
  { VALUE: "Y", TEXT: "Yes" },
  { VALUE: "N", TEXT: "No" },
];
const lcListType = [
  { VALUE: null, TEXT: "All" },
  { VALUE: "PI", TEXT: "PI" },
  { VALUE: "IN", TEXT: "Indent" },
];
const lcListReportType = [
  { VALUE: "SL_2681", TEXT: "LC List" },
  { VALUE: "SL_2682", TEXT: "Document Wise Indent" },
  { VALUE: "SL_2683", TEXT: "Summary" },
  { VALUE: "SL_2684", TEXT: "Document Wise Shipment" },
  { VALUE: "SL_2685", TEXT: "Shipment Summary" },
];
const orderTypeList = [
  { VALUE: "PI", TEXT: "PI" },
  { VALUE: "SI", TEXT: "SI" },
  { VALUE: "CI", TEXT: "CI" },
];

const leaveType = [
  { VALUE: "N", TEXT: "Normal" },
  { VALUE: "L", TEXT: "Limit" },
  { VALUE: "C", TEXT: "Carry Forward" },
  { VALUE: "V", TEXT: "Advancve" },
];
const priority = [
  { VALUE: "", TEXT: "Select" },
  { VALUE: "H", TEXT: "Higher" },
  { VALUE: "L", TEXT: "Lower" },
];
const reqPriority = [
  { VALUE: 1, TEXT: "Normal" },
  { VALUE: 2, TEXT: "Urgent" },
  { VALUE: 3, TEXT: "Fire Urgent" },
];
const behavior = [
  { VALUE: "", TEXT: "Select" },
  { VALUE: "A", TEXT: "Advance" },
  { VALUE: "L", TEXT: "Loan" },
];
const dayMonth = [
  { VALUE: "", TEXT: "Select" },
  { VALUE: "D", TEXT: "Day" },
  { VALUE: "M", TEXT: "Month" },
];
const contributionType = [
  { VALUE: "", TEXT: "Select" },
  { VALUE: "O", TEXT: "Own" },
  { VALUE: "C", TEXT: "Company" },
];
const dayStatusList = [
  { VALUE: "", TEXT: "Select" },
  { VALUE: "N", TEXT: "Work Day" },
  { VALUE: "W", TEXT: "Weekend" },
  { VALUE: "H", TEXT: "Holiday" },
];
const reportList = [
  { TEXT: "Delivery Chalan", VALUE: "1" },
  { TEXT: "Packing List", VALUE: "2" },
  { TEXT: "Gate Pass", VALUE: "3" },
];

const reportListForIn1089 = [
  { TEXT: "Delivery Chalan", VALUE: "D" },
  { TEXT: "Gate Pass", VALUE: "G" },
  { TEXT: "Report Preview", VALUE: "P" },
];
const overTimeOnPer = [
  { VALUE: "1", TEXT: "Payroll Gross" },
  { VALUE: "2", TEXT: "Payroll Basic" },
  { VALUE: "G", TEXT: "Earning Gross" },
  { VALUE: "B", TEXT: "Earning Basic" },
];
const dayMinuteList = [
  { VALUE: "D", TEXT: "Day" },
  { VALUE: "M", TEXT: "Minuit" },
];
const perOnStatusLarge = [
  { VALUE: null, TEXT: "Select" },
  { VALUE: "G", TEXT: "Gross" },
  { VALUE: "B", TEXT: "Basic" },
  { VALUE: "P", TEXT: "Piece & Present" },
  { VALUE: "W", TEXT: "Piece & Workda" },
];
const perOnStatus = [
  { VALUE: "2", TEXT: "Payroll Basic" },
  { VALUE: "1", TEXT: "Payroll Gross" },
  { VALUE: "B", TEXT: "Basic" },
  { VALUE: "G", TEXT: "Gross" },
];
const baseOn = [
  { VALUE: null, TEXT: "Select" },
  { VALUE: 1, TEXT: "Employee Age" },
  { VALUE: 2, TEXT: "Service Age" },
  { VALUE: 3, TEXT: "Gross Salary" },
];
const payrollStatus2 = [
  { VALUE: null, TEXT: "Select" },
  { VALUE: "B", TEXT: "Payroll Basic" },
  { VALUE: "G", TEXT: "Payroll Gross" },
];
const policyPerChantageList = [
  { VALUE: "B", TEXT: "Basic" },
  { VALUE: "G", TEXT: "Gross" },
  { VALUE: "P", TEXT: "Payroll Element" },
];
const monitoringDetail = [
  { VALUE: "D", TEXT: "Day" },
  { VALUE: "M", TEXT: "Month wise" },
];
const monitoringFor = [
  { VALUE: null, TEXT: "All Employee" },
  { VALUE: 1, TEXT: "Active" },
  { VALUE: 0, TEXT: "Inactive" },
];
const monitoringSubordinate = [
  { VALUE: 1, TEXT: "Immediate" },
  { VALUE: 0, TEXT: "All" },
];
const movementPurpose = [
  { VALUE: "O", TEXT: "Office" },
  { VALUE: "P", TEXT: "Personal" },
];
const importLcReportFormet = [
  { VALUE: 1, TEXT: "Format 1" },
  { VALUE: 2, TEXT: "Format 2" },
  { VALUE: 3, TEXT: "Format 3" },
];
const lcPaymentType = [
  { VALUE: "S", TEXT: "LC at Sight" },
  { VALUE: "D", TEXT: "Deffered LC" },
  { VALUE: "A", TEXT: "Advance L/C" },
  { VALUE: "U", TEXT: "UPAS" },
];
const lcTenureOn = [
  { VALUE: "BA", TEXT: "Bank Acceptance Date" },
  { VALUE: "OA", TEXT: "Acceptance Date" },
  { VALUE: "BL", TEXT: "BL Date" },
];
const invAttachedDocType = [{ VALUE: "BD", TEXT: "Bank Document" }];
const drCrList = [
  { VALUE: "Dr", TEXT: "DR" },
  { VALUE: "Cr", TEXT: "CR" },
];
const unapproveStatus = [
  { VALUE: null, TEXT: "All" },
  { VALUE: 1, TEXT: "Approved" },
  { VALUE: 2, TEXT: "Unapprove" },
];
const commercialInvoiceStatus = [
  { VALUE: null, TEXT: "All" },
  { VALUE: 2, TEXT: "Exfact" },
  { VALUE: 3, TEXT: "Doc Submit" },
  { VALUE: 4, TEXT: "Payment" },
  { VALUE: 5, TEXT: "Realized" },
  { VALUE: 6, TEXT: "Increment" },
];

const invoiceDate = [
  { VALUE: "I", TEXT: "Invoice Date" },
  { VALUE: "E", TEXT: "Exfactory Date" },
];
const deliveryOrderType = [
  { TEXT: "Summary", VALUE: "S" },
  { TEXT: "Customer Wise Summary", VALUE: "C" },
  { TEXT: "Customer wise Detail", VALUE: "L" },
  { TEXT: "Item wise", VALUE: "I" },
  { TEXT: "Form", VALUE: "D" },
  { TEXT: "Item wise delivery status", VALUE: "T" },
  { TEXT: "Compensation", VALUE: "CO" },
  { TEXT: "Compensation(Summary)", VALUE: "CS" },
];
const salesOrderType = [
  { VALUE: "RT", TEXT: "Return List" },
  { VALUE: "RTD", TEXT: "Return Details" },
];

const salesInvoiceType = [
  { VALUE: "IL", TEXT: "Invoice List" },
  { VALUE: "ID", TEXT: "Invoice Details" },
  { VALUE: "IT", TEXT: "Invoice Transaction Summary" },
  { VALUE: "IC", TEXT: "Invoice Details with Collection" },
  { VALUE: "IS", TEXT: "Invoice Wise Sales Statement" },
];

const salesDocumentType = [
  { VALUE: "L", TEXT: "L/C List" },
  { VALUE: "D", TEXT: "L/C Details" },
  { VALUE: "S", TEXT: "Sales Person" },
  { VALUE: "T", TEXT: "Customer Wise" },
  { VALUE: "TB", TEXT: "Buyer Wise" },
];

const salesType = [
  { VALUE: 0, TEXT: "External Sales" },
  { VALUE: 1, TEXT: "Internal Sales" },
];

const DataType = [
  { VALUE: 0, TEXT: "Textile" },
  { VALUE: 1, TEXT: "Garments" },
];

const UdType = [
  { VALUE: 1, TEXT: "UD Received" },
  { VALUE: 0, TEXT: "UD Not Received" },
];

const DocumentReportType = [
  { VALUE: "D", TEXT: "Document (Default)" },
  { VALUE: "S", TEXT: "Doc. Wise" },
  { VALUE: "L", TEXT: "LC Position" },
  { VALUE: "P", TEXT: "Payment Follow Up" },
];
const DocumentStatus = [
  { VALUE: "Unrealized", TEXT: "Unrealized" },
  { VALUE: "Negotiated", TEXT: "Negotiated" },
  { VALUE: "BankSubmitted", TEXT: "Bank Submitted" },
  { VALUE: "PartyAccepted", TEXT: "Party Accepted" },
  { VALUE: "PartySubmitted", TEXT: "Party Submitted" },
  { VALUE: "Initialized", TEXT: "Initialized" },
  { VALUE: "Realized", TEXT: "Realized" },
  { VALUE: "Paymentreceived", TEXT: "Payment received" },
];

const effectType = [
  { VALUE: "F", TEXT: "Formula" },
  { VALUE: "S", TEXT: "Fixed" },
  { VALUE: "R", TEXT: "Rest Of formula" },
  { VALUE: "P", TEXT: "Piece Rate" },
];
const factoryType = [
  { VALUE: "M", TEXT: "Multiple Factor" },
  { VALUE: "D", TEXT: "Division Factor" },
  { VALUE: null, TEXT: "Both" },
];

const documentDdeliveryType = [
  { VALUE: 1, TEXT: "With Delivery" },
  { VALUE: 0, TEXT: "Without Delivery" },
];

const formatType = [
  { VALUE: 1, TEXT: "FORMAT 1" },
  { VALUE: 2, TEXT: "FORMAT 2" },
];

const formatTypeApproval = [
  { VALUE: 1, TEXT: "FORMAT 1" },
  { VALUE: 2, TEXT: "FORMAT 2" },
  { VALUE: 3, TEXT: "FORMAT 3" },
  { VALUE: 4, TEXT: "FORMAT 4" },
  { VALUE: 5, TEXT: "FORMAT 5" },
  { VALUE: 6, TEXT: "FORMAT 6" },
  { VALUE: 7, TEXT: "FORMAT 7" },
];

const formatSrl = [
  // { VALUE: 2, TEXT: "Batch" },
  // { VALUE: 3, TEXT: "Roll" },
  // { VALUE: 1, TEXT: "Range" },
  // { VALUE: 0, TEXT: "Location" },
  { VALUE: "IN_24037", TEXT: "Stock Report" },
  { VALUE: "IN_24042", TEXT: "Date Wise Stock Report" },
  { VALUE: "IN_24043", TEXT: "Date Wise Stock Summery" },
  { VALUE: "IN_24045", TEXT: "Year Comparison" },
];
const formatStockReport = [
  { VALUE: 1, TEXT: "Stock Register " },
  { VALUE: 2, TEXT: "Item Stock Batch Role Details" },
  { VALUE: 3, TEXT: "Stock Transaction Summary" },
  { VALUE: 4, TEXT: "Stock Register(Yarn)" },
  { VALUE: 5, TEXT: "Item Stock Batch Wise" },
  { VALUE: 6, TEXT: "Item Consumption" },
  { VALUE: 7, TEXT: "Stock Register( With MC & Internal)" },
  { VALUE: 8, TEXT: "Lot Wise Stock Register" },
  { VALUE: 9, TEXT: "Item Stock Location Details(Gen)" },
  { VALUE: 10, TEXT: "Item Stock Source Wise" },
  { VALUE: 11, TEXT: "Daily  Stock Position" },
  { VALUE: 12, TEXT: "Item Stock Batch And Supplier" },
  { VALUE: 13, TEXT: "Buyer Wise Stock" },
];

const hourList = [
  { VALUE: "FD", TEXT: "Full Day Leave" },
  { VALUE: "HD", TEXT: "Half Day Leave" },
];

const empStatus = [
  { VALUE: 1, TEXT: "Active" },
  { VALUE: 0, TEXT: "Inactive" },
];
const attnStatus = [
  { VALUE: "L", TEXT: "Late" },
  { VALUE: "E", TEXT: "Early" },
  { VALUE: "G", TEXT: "Gate Pass" },
];

const appvStatus = [
  { VALUE: 1, TEXT: "Approved" },
  { VALUE: 0, TEXT: "Pending" },
];
const itemQualityList = [
  { VALUE: "Good", TEXT: "Good" },
  { VALUE: "Damage", TEXT: "Damage" },
  { VALUE: "Broken", TEXT: "Broken" },
];

const calOnList = [
  { VALUE: "BA", TEXT: "Basic Amount" },
  { VALUE: "GA", TEXT: "Gross Amount" },
];

const onList = [
  { VALUE: "B", TEXT: "Basic" },
  { VALUE: "G", TEXT: "Gross" },
];

const itemQualityListIN1301 = [
  { VALUE: "Serviceable", TEXT: "Serviceable" },
  { VALUE: "Unserviceable", TEXT: "Unserviceable" },
];

const vmPurchaseType = [
  { VALUE: "P", TEXT: "Project" },
  { VALUE: "RE", TEXT: "Revenue" },
  { VALUE: "R", TEXT: "Rent" },
  { VALUE: "O", TEXT: "On Test" },
];

const vmFuelType = [
  // { VALUE: 'C', TEXT: "CNG (cm)" },
  { VALUE: "P", TEXT: "Petrol (Ltr)" },
  { VALUE: "O", TEXT: "Octain (Ltr)" },
  { VALUE: "D", TEXT: "Desel (Ltr)" },
];

const allocationStatus = [
  // { VALUE: 'C', TEXT: "CNG (cm)" },
  { VALUE: "A", TEXT: "Assigned" },
  { VALUE: "U", TEXT: "Unassigned" },
];

const issueType = [
  { VALUE: "N", TEXT: "None" },
  { VALUE: "F", TEXT: "Use Batch as FIFO" },
  { VALUE: "L", TEXT: "Use Batch as LIFO" },
  { VALUE: "E", TEXT: "Use Batch as FEFO" },
  { VALUE: "I", TEXT: "Use Intact, FIFO" },
];

const hazardStatus = [
  { VALUE: 1, TEXT: "Yes" },
  { VALUE: 0, TEXT: "No" },
];

const invItemhazardStatus = [
  { VALUE: "Hazardous", TEXT: "Hazardous" },
  { VALUE: "Non Hazardous", TEXT: "Non Hazardous" },
  { VALUE: "NO Status", TEXT: "NO Status" },
];

const yarnType = [
  { VALUE: "E", TEXT: "English" },
  { VALUE: "D", TEXT: "Denier" },
];

const invMethodType = [
  { VALUE: "F", TEXT: "FIFO" },
  { VALUE: "L", TEXT: "LIFO" },
  { VALUE: "W", TEXT: "WA" },
  { VALUE: "B", TEXT: "BATCH" },
  { VALUE: "D", TEXT: "@ O Rate" },
];

const itemMethodType = [
  { VALUE: "F", TEXT: "FIFO" },
  { VALUE: "L", TEXT: "LIFO" },
  { VALUE: "W", TEXT: "WA" },
  { VALUE: "E", TEXT: "FEFO" },
];

const issueTypeForItem = [
  { VALUE: "R", TEXT: "Issue as Revenue Item" },
  { VALUE: "C", TEXT: " Issue as Capital Item" },
];

//Straight Line=SL,Declining Balance=DB,Sum of the years digits method=SD

const depreciationMethod = [
  { VALUE: "SL", TEXT: "Straight Line" },
  { VALUE: "DB", TEXT: "Declining Balance" },
  { VALUE: "SD", TEXT: "Sum of the years digits method" },
];

//Yearly=Y,Half Yearly=H,Quarterly=Q,Monthly=M
const depreciationPeriod = [
  { VALUE: "Y", TEXT: "Yearly" },
  { VALUE: "H", TEXT: "Half Yearly" },
  { VALUE: "Q", TEXT: "Quarterly" },
  { VALUE: "M", TEXT: "Monthly" },
];

const letterType = [
  { VALUE: "WL", TEXT: "With Letter" },
  { VALUE: "WOL", TEXT: "Without letter" },
  { VALUE: "SUM", TEXT: "Details" },
];
const type = [
  { VALUE: "I", TEXT: "Internal" },
  { VALUE: "P", TEXT: "Purchase" },
  { VALUE: "S", TEXT: "Sales" },
];
const transactionReportType = [
  { VALUE: "I", TEXT: "Internal" },
  { VALUE: "P", TEXT: "Purchase" },
];

const stockValuation = [
  { VALUE: "S", TEXT: "Stock Balance (Qty)" },
  { VALUE: "IL", TEXT: "Item Level" },
  { VALUE: "GL", TEXT: "Item Group Level" },
  { VALUE: "MC", TEXT: "Inter Company" },
  { VALUE: "GW", TEXT: "Group Wise" },
  { VALUE: "G", TEXT: "Defult" },
  { VALUE: "T", TEXT: "Summary" },
  { VALUE: "LE", TEXT: "Item Ledger" },
];
const in2520StockValuation = [
  { VALUE: "S", TEXT: "Stock Balance (Qty)" },
  // { VALUE: 'IL', TEXT: "Item Level" },
  // { VALUE: 'GL', TEXT: "Item Group Level" },
  // { VALUE: 'MC', TEXT: "Inter Company" },
  // { VALUE: 'GW', TEXT: "Group Wise" },
  { VALUE: "G", TEXT: "Defult" },
  { VALUE: "T", TEXT: "Summary" },
  // { VALUE: 'LE', TEXT: "Item Ledger" },
];

const stockAgingReportType = [
  { VALUE: "B", TEXT: "Batch Type" },
  { VALUE: "G", TEXT: "Group Wise" },
  { VALUE: "AG", TEXT: "Aging (On Valuation)" },
  { VALUE: "AGgrp", TEXT: "Aging On Valuation (Group)" },
  { VALUE: "UN", TEXT: "Unused Item" },
];

const itemLedgerType = [
  { VALUE: "L", TEXT: "Item Ledger" },
  { VALUE: "D", TEXT: "Ledger Format-2" },
  { VALUE: "BL", TEXT: "Ledger Format-BL" },
  { VALUE: "I", TEXT: "Item Wise Projected Consumption Days" },
  { VALUE: "R", TEXT: "Item Wise Last Receive Issue" },
];

const receiveTypeList = [
  { VALUE: "S", TEXT: "Summary" },
  { VALUE: "D", TEXT: "Details" },
  { VALUE: "RR", TEXT: "Rate Range" },
  { VALUE: "RD", TEXT: "Rate Details" },
  { VALUE: "BR", TEXT: "Bin Card Receive" },
  { VALUE: "YP", TEXT: "Yarn Price History" },
  { VALUE: "OL", TEXT: "Only Last Purchase" },
  { VALUE: "MB", TEXT: "Missing Batch Quantity" },
];

const in2810ReceiveTypeList = [
  { VALUE: "S", TEXT: "Summary" },
  { VALUE: "D", TEXT: "Details" },
  { VALUE: "RR", TEXT: "Rate Range" },
  { VALUE: "RD", TEXT: "Rate Details" },
  { VALUE: "PRR", TEXT: "Product Receive Report" },
  { VALUE: "TR", TEXT: "Transit Report" },
  { VALUE: "MRR", TEXT: "Material Return Report" },
  { VALUE: "RCV", TEXT: "Receive Report" },
  { VALUE: "ITR", TEXT: "In Transit Report" },
  { VALUE: "MRS", TEXT: "MRS Receive Report" },
  { VALUE: "IN_28120", TEXT: "Group Wise Receive Summary" },
  { VALUE: "IN_28121", TEXT: "Supplier Wise Receive Summary" },
  { VALUE: "IN_28122", TEXT: "Monthly MRR Report" },
  // Group Wise Receive Summary=IN_28120, Supplier Wise Receive Summary=IN_28121, Monthly MRR Report=IN_28122

  // { VALUE: 'BR', TEXT: "Bin Card Receive" },
  // { VALUE: 'YP', TEXT: "Yarn Price History" },
  // { VALUE: 'OL', TEXT: "Only Last Purchase" },
  // { VALUE: 'MB', TEXT: "Missing Batch Quantity" },
];

const receiveUnit = [
  { VALUE: 1, TEXT: "Min Unit Price" },
  { VALUE: 2, TEXT: "Max Unit Price" },
  { VALUE: 3, TEXT: "ACT Min Unit Price" },
  { VALUE: 4, TEXT: "ACT Max Unit Price" },
];

const pctOn = [
  { VALUE: "B", TEXT: "Basic" },
  { VALUE: "G", TEXT: "Gross" },
  { VALUE: "P", TEXT: "Payroll Element" },
];

const genderListHr1180 = [
  { VALUE: 1, TEXT: "Male" },
  { VALUE: 2, TEXT: "Female" },
  { VALUE: 0, TEXT: "N/A" },
];

const receiveCompare = [
  { VALUE: "=", TEXT: "=" },
  { VALUE: ">=", TEXT: ">=" },
  { VALUE: "<", TEXT: "<" },
];

const preferredList = [
  { VALUE: "M", TEXT: "Mobile" },
  { VALUE: "O", TEXT: "Office" },
  { VALUE: "H", TEXT: "Home" },
];

const supplierOfferList = [
  { VALUE: 1, TEXT: "with Supplier offer" },
  { VALUE: 2, TEXT: "without Supplier offer" },
];

const preferedAddressList = [
  { VALUE: "PR", TEXT: "Present" },
  { VALUE: "PE", TEXT: "Permanent" },
];

const vmReportTypes = [
  { VALUE: "Vehicle Information", TEXT: "Vehicle Information" },
  { VALUE: "Tax Token Renewable", TEXT: "Tax Token Renewable" },
  { VALUE: "Insurance Renewable", TEXT: "Insurance Renewable" },
  { VALUE: "Vehicle Assign Information", TEXT: "Vehicle Assign Information" },
];

const pmPriorityList = [
  { VALUE: 1, TEXT: "01" },
  { VALUE: 2, TEXT: "02" },
  { VALUE: 3, TEXT: "03" },
  { VALUE: 4, TEXT: "04" },
  { VALUE: 5, TEXT: "05" },
  { VALUE: 6, TEXT: "06" },
  { VALUE: 7, TEXT: "07" },
  { VALUE: 8, TEXT: "08" },
  { VALUE: 9, TEXT: "09" },
  { VALUE: 10, TEXT: "10" },
];

const prlVerificationRegister = [
  { VALUE: "A", TEXT: "Verified" },
  { VALUE: "W", TEXT: "Waiting" },
  { VALUE: "D", TEXT: "Denied" },
];

const prlFileInitiate = [
  { VALUE: "A", TEXT: "Approved" },
  { VALUE: "W", TEXT: "Waiting" },
];

const prlHodApplicationRegister = [
  { VALUE: "A", TEXT: "Verified" },
  { VALUE: "W", TEXT: "Waiting" },
];

const prlApplicationRegister = [
  { VALUE: "W", TEXT: "Waiting" },
  { VALUE: "C", TEXT: "Completed" },
];

const apiType = [
  { VALUE: "list", TEXT: "List" },
  { VALUE: "single", TEXT: "Single" },
];

const calcOnHr1218 = [
  { VALUE: "BA", TEXT: "Basic Amount" },
  { VALUE: "GA", TEXT: "Gross Amount" },
  { VALUE: "AM", TEXT: "Age (Month)" },
  { VALUE: "DR", TEXT: "Date Range (YYYYMMDD)" },
];

const pctOnHr1218 = [
  { VALUE: "B", TEXT: "Basic" },
  { VALUE: "G", TEXT: "Gross" },
];

const dateFormatForAccountConfig = [
  { VALUE: "RRRRMMDD", TEXT: "YYYYMMDD" },
  { VALUE: "RRMMDD", TEXT: "YYMMDD" },
  { VALUE: "MMRRDD", TEXT: "MMYYDD" },
  { VALUE: "DDMMRR", TEXT: "DDMMYY" },
  { VALUE: "MMYY", TEXT: "MMRR" },
  { VALUE: "YYMM", TEXT: "RRMM" },
  { VALUE: "YY", TEXT: "RR" },
];

export const fixedValues: any = {
  depreciationPeriod: depreciationPeriod,
  supplierOfferList: supplierOfferList,
  receiveCompare: receiveCompare,
  receiveUnit: receiveUnit,
  receiveTypeList: receiveTypeList,
  in2810ReceiveTypeList: in2810ReceiveTypeList,
  depreciationMethod: depreciationMethod,
  issueTypeForItem: issueTypeForItem,
  invMethodType: invMethodType,
  itemMethodType: itemMethodType,
  yarnType: yarnType,
  itemLedgerType: itemLedgerType,
  letterType: letterType,
  stockValuation: stockValuation,
  in2520StockValuation: in2520StockValuation,
  transactionReportType: transactionReportType,
  stockAgingReportType: stockAgingReportType,
  type: type,
  hazardStatus: hazardStatus,
  invItemhazardStatus: invItemhazardStatus,
  issueType: issueType,
  empStatus: empStatus,
  attnStatus: attnStatus,
  appvStatus: appvStatus,
  itemQualityList: itemQualityList,
  itemQualityListIN1301: itemQualityListIN1301,
  drCrList: drCrList,

  invAttachedDocType: invAttachedDocType,
  applyOn: applyOn,
  invoiceCategory: invoiceCategory,
  recieveLoanAmt: recieveLoanAmt,
  paymentFrequency: paymentFrequency,
  recieveStatusLoan: recieveStatusLoan,
  recieveStatus1: recieveStatus1,
  dateStatus: dateStatus,
  moneyReqStatus: moneyReqStatus,
  rateType: rateType,
  reply: reply,
  moreAction: moreAction,
  sqlState: sqlState,
  taskType: taskType,
  checkFlag: checkFlag,
  queryOptions: queryOptions,
  voucherType: voucherType,
  transactionType: transactionType,
  accountType: accountType,
  coaIndentificationType: coaIndentificationType,
  coaDisplayType: coaDisplayType,
  postingStatus: postingStatus,
  voucherModeType: voucherModeType,
  generationType: generationType,
  indentificationAccountType: indentificationAccountType,
  integratedModuleType: integratedModuleType,
  confirmedType: confirmedType,
  nameCodeStyleType: nameCodeStyleType,
  balanceType: balanceType,
  postStatusType: postStatusType,
  postingStatusType: postingStatusType,
  printTypeList: printTypeList,
  postStatusType1: postStatusType1,
  ccBaType: ccBaType,
  allocateCostCenters: allocateCostCenters,
  inventoryTypes: inventoryTypes,
  reportOptionList: reportOptionList,
  reportFormat: reportFormat,
  activeType: activeType,
  filterOptionType: filterOptionType,
  settlementType: settlementType,
  budgetModeType: budgetModeType,
  reportOptionTypeList: reportOptionTypeList,
  reportCategoryTypeList: reportCategoryTypeList,
  reportTypeList: reportTypeList,
  dayBookreportTypeList: dayBookreportTypeList,
  status: status,
  dateType: dateType,
  billStatus: billStatus,
  salesInvoiceDateType: salesInvoiceDateType,
  fromOrderInvoice: fromOrderInvoice,
  billStatus1: billStatus1,
  salesNegotiationType: salesNegotiationType,
  salesRealizationType: salesRealizationType,
  billRegisterType: billRegisterType,
  saleReturnType: saleReturnType,
  issueReportType: issueReportType,
  dcdoDate: dcdoDate,
  lcType: lcType,
  moneyReqStatus01: moneyReqStatus01,
  duration: duration,
  acceptedType: acceptedType,
  acceptType: acceptType,
  paymentStatus: paymentStatus,
  probisionData: probisionData,
  bblcDateType: bblcDateType,
  auditStatus: auditStatus,
  billType: billType,
  inBillTypes: inBillTypes,
  requisitiontype1284: requisitiontype1284,
  requisitiontype1310: requisitiontype1310,
  billTypeStatus: billTypeStatus,
  ApproveStatus: ApproveStatus,
  purchaseBillTypes: purchaseBillTypes,
  purchaseBillTypes1: purchaseBillTypes1,
  auditStatusBillPayment: auditStatusBillPayment,
  lcType2: lcType2,
  postStatus: postStatus,
  invoiceType: invoiceType,
  invoiceType1: invoiceType1,
  deliveryType: deliveryType,
  deliveryTypeOne: deliveryTypeOne,
  promotionTypeStatusSingle: promotionTypeStatusSingle,
  invoiceStatus: invoiceStatus,
  approvalLayerStatus: approvalLayerStatus,
  sa1046TaskTypeList: sa1046TaskTypeList,
  transactionStatus: transactionStatus,
  voucherType2: voucherType2,
  transactionTypeUpperCase: transactionTypeUpperCase,
  transferType: transferType,
  transferType1059: transferType1059,
  transferStatus: transferStatus,
  loanType: loanType,
  orderType: orderType,
  inventoryMethos: inventoryMethos,
  orderType1: orderType1,
  referenceStatus: referenceStatus,
  lcBasis: lcBasis,
  quantityUnitType: quantityUnitType,
  quantityUnitTypeTwo: quantityUnitTypeTwo,
  dobProvedBy: dobProvedBy,
  maritialStatus: maritialStatus,
  activeStatus: activeStatus,
  activeStatusList: activeStatusList,
  activeStatusListHr1016: activeStatusListHr1016,
  activeStatusListSa1028: activeStatusListSa1028,

  missingStatusList: missingStatusList,
  adjustWithList: adjustWithList,
  adjustTypeList: adjustTypeList,
  woTypeList: woTypeList,
  collectionType: collectionType,

  activeStatusTwo: activeStatusTwo,
  requisitionStatus: requisitionStatus,
  imageFormateList: imageFormateList,
  cardGenaratorType: cardGenaratorType,
  applicationNameFormate: applicationNameFormate,
  bainaryType: bainaryType,
  prefixSuffix: prefixSuffix,
  userPermissionType: userPermissionType,
  genderStatus: genderStatus,
  offDayStatyus: offDayStatyus,
  languageProfieancyStatus: languageProfieancyStatus,
  reportFormatFourStyle: reportFormatFourStyle,
  transactionType1113: transactionType1113,
  reportFormatFourStyleWo: reportFormatFourStyleWo,
  yearStatus: yearStatus,
  monthStatus: monthStatus,
  status1: status1,
  rbType: rbType,
  shipmentMode: shipmentMode,
  shipmentMode2: shipmentMode2,
  approvalStatus: approvalStatus,
  approvalStatus1: approvalStatus1,
  dateTypeStatus: dateTypeStatus,
  workOrderStatus: workOrderStatus,
  workOrderStatus1: workOrderStatus1,
  currectionTypeList: currectionTypeList,
  workOrderStatusSl: workOrderStatusSl,
  recieveStatus: recieveStatus,
  salaryOperator: salaryOperator,
  paymentMood: paymentMood,
  transferTypeStatus: transferTypeStatus,
  transferTypeStatus01: transferTypeStatus01,
  payrollStatus: payrollStatus,
  supplierCategoryList: supplierCategoryList,
  clStatusList: clStatusList,
  docStatusList: docStatusList,
  carbonList: carbonList,
  reportFormatList: reportFormatList,
  reportFormatListOne: reportFormatListOne,
  storeReportList: storeReportList,
  shiftWiseList: shiftWiseList,
  statisticsType: statisticsType,
  perChantageList: perChantageList,
  dicsType: dicsType,
  dicsOn: dicsOn,
  imageHolderList: imageHolderList,
  lcReqList: lcReqList,
  lcReqList1: lcReqList1,
  itemDestType: itemDestType,
  payrollStatus1: payrollStatus1,
  purchaseTypeList: purchaseTypeList,
  manPowerStatus: manPowerStatus,
  applicationType: applicationType,
  otStatus: otStatus,
  workOrderStatusTwo: workOrderStatusTwo,
  salesReportSatus: salesReportSatus,
  printCopyFormat: printCopyFormat,
  referenceList: referenceList,
  loanRegStatus: loanRegStatus,
  purchaseOrderTypeList: purchaseOrderTypeList,
  purchaseOrderStatusList: purchaseOrderStatusList,
  purchaseRequisitionTypeList: purchaseRequisitionTypeList,
  purchaseRequisitionStatusList: purchaseRequisitionStatusList,
  purchaseTransactionSummaryList: purchaseTransactionSummaryList,
  budgetTypeList: budgetTypeList,
  financialStatementType: financialStatementType,
  isBudgetList: isBudgetList,
  csReprotTypeList: csReprotTypeList,
  salePaymentType: salePaymentType,
  reqPaymentType: reqPaymentType,
  activeStatusIn1013: activeStatusIn1013,

  bankTypeList: bankTypeList,
  importReportTypeList: importReportTypeList,
  purchaseAnalysisTypeList: purchaseAnalysisTypeList,
  importLeaveTypeList: importLeaveTypeList,
  attendaceList: attendaceList,
  genderList: genderList,
  maturityType: maturityType,
  summeryTypeList: summeryTypeList,
  reportEmpList: reportEmpList,
  importLcReportTypeList: importLcReportTypeList,
  documentWisePurchaseStatementType: documentWisePurchaseStatementType,
  printCopyFormat2: printCopyFormat2,
  reportTypeListOne: reportTypeListOne,
  handoverTransportType: handoverTransportType,
  acceptedType2: acceptedType2,
  reqStatus: reqStatus,
  procurementStaus: procurementStaus,
  reportSizeList: reportSizeList,
  salaryTypeList: salaryTypeList,
  statementList: statementList,
  statementList1: statementList1,
  transactionAction: transactionAction,
  statementForList: statementForList,
  incrementSuggestionReportFormetType: incrementSuggestionReportFormetType,
  reportFormatListTwo: reportFormatListTwo,
  reportFormatListThree: reportFormatListThree,
  incrementSuggestionReportCheckType: incrementSuggestionReportCheckType,
  incrementSuggestionActiveStatus: incrementSuggestionActiveStatus,
  earnLeavePaymentReportFormat: earnLeavePaymentReportFormat,
  salesInvoiceReportFormat: earnLeavePaymentReportFormat,
  earnLeavePaymentReportType: earnLeavePaymentReportType,
  dailyStatusList: dailyStatusList,
  activeStatusCom: activeStatusCom,
  activeStatusCom1: activeStatusCom1,
  employeeWiseAttendaceReportFormetDefault:
    employeeWiseAttendaceReportFormetDefault,
  employeeWiseAttendaceReportFormetSummary:
    employeeWiseAttendaceReportFormetSummary,
  employeeWiseAttendaceType: employeeWiseAttendaceType,
  employeeWiseAttendaceReportType: employeeWiseAttendaceReportType,
  conditionStatus: conditionStatus,
  methodTypeList: methodTypeList,
  conditionRosterStatus: conditionRosterStatus,
  calOn: calOn,
  calOn01: calOn01,
  formulaOn: formulaOn,
  typeList: typeList,
  calDayType: calDayType,
  lateDayType: lateDayType,
  moduleList: moduleList,
  paymentBy: paymentBy,
  paymentBy1: paymentBy1,
  policyStatus: policyStatus,
  policyStatus01: policyStatus01,
  searchArea: searchArea,
  supplierAccount: supplierAccount,

  reportFormatListForAllowance: reportFormatListForAllowance,
  dailyOrMonthly: dailyOrMonthly,
  calNoOption: calNoOption,
  durationYear: durationYear,
  durationMonth: durationMonth,
  durationDay: durationDay,
  durationYearOperator: durationYearOperator,
  durationMonthOperator: durationMonthOperator,
  durationDayOperator: durationDayOperator,
  imageShowList: imageShowList,
  approveStatus: approveStatus,
  statementListOne: statementListOne,
  grossStatus: grossStatus,
  adjustType: adjustType,
  adjustWith: adjustWith,
  salPayMood: salPayMood,
  employeeListReport: employeeListReport,
  employeeListReportOne: employeeListReportOne,
  EmployeeStatusList: EmployeeStatusList,
  paymentMode: paymentMode,
  paymentMode1: paymentMode1,
  departmentList: departmentList,
  salaryType: salaryType,
  overTimeRequisitionType: overTimeRequisitionType,
  otType: otType,
  productItem: productItem,
  overTimeRequisitionReportFormat: overTimeRequisitionReportFormat,
  equisitionReportFormat: equisitionReportFormat,
  issueAs: issueAs,
  purposeTypeList: purposeTypeList,
  purposeTypeList1: purposeTypeList1,
  absentConterList: absentConterList,
  absentConterList1: absentConterList1,
  currectionType: currectionType,
  leaveRegisterHistoryReportType: leaveRegisterHistoryReportType,
  activeStatusLeaveRegisterHistory: activeStatusLeaveRegisterHistory,
  activeStatusLeaveRegisterHistory1: activeStatusLeaveRegisterHistory1,
  trainingStatus: trainingStatus,
  finalSettlementStatementReportType: finalSettlementStatementReportType,
  billPaymentReportType: billPaymentReportType,
  billPaymentPayableStatus: billPaymentPayableStatus,
  reportTypeListTwo: reportTypeListTwo,
  earningStatusList: earningStatusList,
  reportFormatFourStyleOne: reportFormatFourStyleOne,
  reportFormatFourStyleOne1: reportFormatFourStyleOne1,
  printReport: printReport,
  overtimeRateList: overtimeRateList,
  previewDataForList: previewDataForList,
  manPowerStatusTypeList: manPowerStatusTypeList,
  manPowerStatusTypeList1: manPowerStatusTypeList1,
  loanHistoryReportType: loanHistoryReportType,
  behaviorList: behaviorList,
  attendanceBonusReportType: attendanceBonusReportType,
  companyType: companyType,
  gatePassType: gatePassType,
  loanReportType: loanReportType,
  paymentCompleteStatus: paymentCompleteStatus,
  paymentStatusPaySalary: paymentStatusPaySalary,
  paymentStatusPaySalary1: paymentStatusPaySalary1,
  employeeSalaryStatus: employeeSalaryStatus,
  employeeSalaryStatus1: employeeSalaryStatus1,
  reportTitleForPaySalary: reportTitleForPaySalary,
  testReportPriceType: testReportPriceType,
  salesReportType: salesReportType,
  stockTypeList: stockTypeList,
  pendingLcDateOptions: pendingLcDateOptions,
  marketingSalesReportType: marketingSalesReportType,
  receivableLedgerReportType: receivableLedgerReportType,
  yesOrNo: yesOrNo,
  itemSerialList: itemSerialList,
  inventoryType: inventoryType,
  stockCategory: stockCategory,
  activeStatusThree: activeStatusThree,
  processedStatus: processedStatus,
  paymentType: paymentType,
  salesTransactionType: salesTransactionType,
  transactionActionPur: transactionActionPur,
  transactionActionSl: transactionActionSl,
  lcListType: lcListType,
  lcListReportType: lcListReportType,
  requisitionHistoryStatus: requisitionHistoryStatus,
  amountStatus: amountStatus,
  leaveType: leaveType,
  loanReqType: loanReqType,
  loanTransactionType: loanTransactionType,
  itemMovementType: itemMovementType,
  inPaymentType: inPaymentType,
  weekStatus: weekStatus,
  intervalStats: intervalStats,
  itemQuality: itemQuality,
  secoundRoundingStatus: secoundRoundingStatus,
  manpowerStrengthReqApprovalStatusList: manpowerStrengthReqApprovalStatusList,
  overTimeRequisitionReportFormat2: overTimeRequisitionReportFormat2,
  statusTwo: statusTwo,
  reportListForIn1089: reportListForIn1089,
  offDayStatus: offDayStatus,
  statusThree: statusThree,
  tranDate: tranDate,
  tiffinType: tiffinType,
  behaviourStatus: behaviourStatus,
  transactionRelatedTo: transactionRelatedTo,
  transactionRelatedToSl: transactionRelatedToSl,
  otherType: otherType,
  taxBehavior: taxBehavior,
  recurring: recurring,
  percentOn: percentOn,
  percentOn1003: percentOn1003,
  gradeStatus: gradeStatus,
  promotionTypeStatus: promotionTypeStatus,
  promotionPayrollStatus: promotionPayrollStatus,
  ActualIncrNoList: ActualIncrNoList,
  transferTypeStatus1: transferTypeStatus1,
  overTimeReqStatusList: overTimeReqStatusList,
  in1295OverTimeReqStatusList: in1295OverTimeReqStatusList,
  genderStatus2: genderStatus2,
  priority: priority,
  reqPriority: reqPriority,
  behavior: behavior,
  dayMonth: dayMonth,
  activeType1: activeType1,
  contributionType: contributionType,
  dayStatusList: dayStatusList,
  overTimeOnPer: overTimeOnPer,
  dayMinuteList: dayMinuteList,
  perOnStatusLarge: perOnStatusLarge,
  baseOn: baseOn,
  payrollStatus2: payrollStatus2,
  monitoringDetail: monitoringDetail,
  monitoringFor: monitoringFor,
  monitoringSubordinate: monitoringSubordinate,
  compateWithList: compateWithList,
  reportTypeApplicant: reportTypeApplicant,
  movementPurpose: movementPurpose,
  importLcReportFormet: importLcReportFormet,
  lcPaymentType: lcPaymentType,
  lcTenureOn: lcTenureOn,
  perOnStatus: perOnStatus,
  loanStatus: loanStatus,
  preferred: preferred,
  genderList3: genderList3,
  orderTypeList: orderTypeList,
  activeStatusCurrentMonth: activeStatusCurrentMonth,
  reportList: reportList,
  postedStatus: postedStatus,
  purchaseBillTypes2: purchaseBillTypes2,
  shipType: shipType,
  carierType: carierType,
  acceptanceType: acceptanceType,
  postStatusTypeNumber: postStatusTypeNumber,
  postStatusTypeNumberIn1027: postStatusTypeNumberIn1027,
  issueTypeList: issueTypeList,
  inReportFormat: inReportFormat,
  serviceType: serviceType,
  POStatus: POStatus,
  discountType: discountType,
  profomaInvoiceType: profomaInvoiceType,
  delModeStatus: delModeStatus,
  session: session,
  billStatus2: billStatus2,
  lcTypeThree: lcTypeThree,
  sourceStatus: sourceStatus,
  rcvStatus: rcvStatus,
  itemQualityStatus: itemQualityStatus,
  reportTypeListThree: reportTypeListThree,
  reportCategory: reportCategory,
  reportEarnLeavePayment: reportEarnLeavePayment,
  valueTipe: valueTipe,
  shipmentEntryStatus: shipmentEntryStatus,
  shipmentEntryReportType: shipmentEntryReportType,
  issueProcess: issueProcess,
  maintainceType: maintainceType,
  lcStatus: lcStatus,
  reportTitleForSalaryStatement: reportTitleForSalaryStatement,
  purchaseBillType2: purchaseBillType2,
  billReport: billReport,
  SummeryReportTypeList: SummeryReportTypeList,
  unapproveStatus: unapproveStatus,
  commercialInvoiceStatus: commercialInvoiceStatus,
  invoiceDate: invoiceDate,
  shipmentMode3: shipmentMode3,
  deliveryOrderType: deliveryOrderType,
  salesOrderType: salesOrderType,
  salesInvoiceType: salesInvoiceType,
  salesDocumentType: salesDocumentType,
  salesType: salesType,
  DataType: DataType,
  UdType: UdType,
  DocumentReportType: DocumentReportType,
  DocumentStatus: DocumentStatus,
  documentDdeliveryType: documentDdeliveryType,
  effectType: effectType,
  factoryType: factoryType,
  formatType: formatType,
  formatTypeApproval: formatTypeApproval,
  formatStockReport: formatStockReport,
  formatSrl: formatSrl,
  hourList: hourList,
  policyPerChantageList: policyPerChantageList,
  payScheduleStatus: payScheduleStatus,
  requisitionType: requisitionType,
  trnsactionTypeIn1026: trnsactionTypeIn1026,
  statusGroup: statusGroup,
  userType: userType,
  genderSa1028: genderSa1028,
  maritialStatusSa1028: maritialStatusSa1028,
  incommingProtocolList: incommingProtocolList,
  outgoingProtocolList: outgoingProtocolList,
  preferredList: preferredList,
  preferedAddressList: preferedAddressList,
  sa1008FilterType: sa1008FilterType,
  transferIssue: transferIssue,
  reportFormatFourStyleWoIn1297: reportFormatFourStyleWoIn1297,
  calOnList: calOnList,
  onList: onList,
  pctOn: pctOn,
  genderListHr1180: genderListHr1180,
  activeStatusVm: activeStatusVm,
  vmPurchaseType: vmPurchaseType,
  vmFuelType: vmFuelType,
  statusListhr1188: statusListhr1188,
  vmReportTypes: vmReportTypes,
  pmPriorityList: pmPriorityList,
  statusListhr1189: statusListhr1189,
  statusListhr1190: statusListhr1190,
  shortMonths: shortMonths,
  statusList: statusList,
  reportHR1182: reportHR1182,
  statusListHR1197: statusListHR1197,
  returnType: returnType,
  statusHr1192: statusHr1192,
  vmApprovalStatus: vmApprovalStatus,
  vmSeatRequisitionApprovalStatus: vmSeatRequisitionApprovalStatus,
  vmSaetAllocationStatus: vmSaetAllocationStatus,
  prlFileInitiate: prlFileInitiate,
  prlVerificationRegister: prlVerificationRegister,
  prlHodApplicationRegister: prlHodApplicationRegister,
  prlApplicationRegister: prlApplicationRegister,
  prePRLListStatus: prePRLListStatus,
  maxAmtBy: maxAmtBy,
  apiType: apiType,
  statusPrl: statusPrl,
  methodHR1007: methodHR1007,
  collectionTypeHr1007: collectionTypeHr1007,
  hr1002TrainingType: hr1002TrainingType,
  hr1002relationType: hr1002relationType,
  specialAwardBonusType,
  installmentList,
  allocationStatus,
  qcStatus,
  genderStatusHR1218,
  calcOnHr1218,
  pctOnHr1218,
  incrementTYpe,
  calOn2,
  rateType2,
  dateFormatForAccountConfig: dateFormatForAccountConfig,
  periodTypeList: periodTypeList,
};
